import { z } from 'zod';

import { OptionalPhoneNumber } from '../../../Phone';
import { OptionalEmailString } from '../../email';
import { AddressLine, Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

export const MultiPropertyInsuranceFields = z.object({
  address2HazardInsuranceIsEscrowed: Checkbox.optional(),
  address2HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2HazardInsuranceAgentName: z.string().optional(),
  address2HazardInsuranceAgentEmail: OptionalEmailString,
  address2HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address2HazardInsuranceCompanyName: z.string().optional(),
  address2HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2HazardInsuranceCompanyAddressCity: z.string().optional(),
  address2HazardInsuranceCompanyAddressState: z.string().optional(),
  address2HazardInsuranceCompanyAddressZip: z.string().optional(),
  address2HazardInsurancePolicyNumber: z.string().optional(),
  address2HazardInsurancePolicyStart: DateString.optional(),
  address2HazardInsurancePolicyEnd: DateString.optional(),
  address2HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address2HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2HomeownersInsuranceAgentName: z.string().optional(),
  address2HomeownersInsuranceAgentEmail: OptionalEmailString,
  address2HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address2HomeownersInsuranceCompanyName: z.string().optional(),
  address2HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address2HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address2HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address2HomeownersInsurancePolicyNumber: z.string().optional(),
  address2HomeownersInsurancePolicyStart: DateString.optional(),
  address2HomeownersInsurancePolicyEnd: DateString.optional(),
  address2HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2FloodInsuranceIsEscrowed: Checkbox.optional(),
  address2FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2FloodInsuranceAgentName: z.string().optional(),
  address2FloodInsuranceAgentEmail: OptionalEmailString,
  address2FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address2FloodInsuranceCompanyName: z.string().optional(),
  address2FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2FloodInsuranceCompanyAddressCity: z.string().optional(),
  address2FloodInsuranceCompanyAddressState: z.string().optional(),
  address2FloodInsuranceCompanyAddressZip: z.string().optional(),
  address2FloodInsurancePolicyNumber: z.string().optional(),
  address2FloodInsurancePolicyStart: DateString.optional(),
  address2FloodInsurancePolicyEnd: DateString.optional(),
  address2FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address2WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2WindstormInsuranceAgentName: z.string().optional(),
  address2WindstormInsuranceAgentEmail: OptionalEmailString,
  address2WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address2WindstormInsuranceCompanyName: z.string().optional(),
  address2WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address2WindstormInsuranceCompanyAddressState: z.string().optional(),
  address2WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address2WindstormInsurancePolicyNumber: z.string().optional(),
  address2WindstormInsurancePolicyStart: DateString.optional(),
  address2WindstormInsurancePolicyEnd: DateString.optional(),
  address2WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address2HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2HurricaneInsuranceAgentName: z.string().optional(),
  address2HurricaneInsuranceAgentEmail: OptionalEmailString,
  address2HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address2HurricaneInsuranceCompanyName: z.string().optional(),
  address2HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address2HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address2HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address2HurricaneInsurancePolicyNumber: z.string().optional(),
  address2HurricaneInsurancePolicyStart: DateString.optional(),
  address2HurricaneInsurancePolicyEnd: DateString.optional(),
  address2HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2FireInsuranceIsEscrowed: Checkbox.optional(),
  address2FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2FireInsuranceAgentName: z.string().optional(),
  address2FireInsuranceAgentEmail: OptionalEmailString,
  address2FireInsuranceAgentPhone: OptionalPhoneNumber,
  address2FireInsuranceCompanyName: z.string().optional(),
  address2FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2FireInsuranceCompanyAddressCity: z.string().optional(),
  address2FireInsuranceCompanyAddressState: z.string().optional(),
  address2FireInsuranceCompanyAddressZip: z.string().optional(),
  address2FireInsurancePolicyNumber: z.string().optional(),
  address2FireInsurancePolicyStart: DateString.optional(),
  address2FireInsurancePolicyEnd: DateString.optional(),
  address2FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address2LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2LiabilityInsuranceAgentName: z.string().optional(),
  address2LiabilityInsuranceAgentEmail: OptionalEmailString,
  address2LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address2LiabilityInsuranceCompanyName: z.string().optional(),
  address2LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address2LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address2LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address2LiabilityInsurancePolicyNumber: z.string().optional(),
  address2LiabilityInsurancePolicyStart: DateString.optional(),
  address2LiabilityInsurancePolicyEnd: DateString.optional(),
  address2LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2RentalInsuranceIsEscrowed: Checkbox.optional(),
  address2RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2RentalInsuranceAgentName: z.string().optional(),
  address2RentalInsuranceAgentEmail: OptionalEmailString,
  address2RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address2RentalInsuranceCompanyName: z.string().optional(),
  address2RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2RentalInsuranceCompanyAddressCity: z.string().optional(),
  address2RentalInsuranceCompanyAddressState: z.string().optional(),
  address2RentalInsuranceCompanyAddressZip: z.string().optional(),
  address2RentalInsurancePolicyNumber: z.string().optional(),
  address2RentalInsurancePolicyStart: DateString.optional(),
  address2RentalInsurancePolicyEnd: DateString.optional(),
  address2RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2CondoInsuranceIsEscrowed: Checkbox.optional(),
  address2CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2CondoInsuranceAgentName: z.string().optional(),
  address2CondoInsuranceAgentEmail: OptionalEmailString,
  address2CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address2CondoInsuranceCompanyName: z.string().optional(),
  address2CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2CondoInsuranceCompanyAddressCity: z.string().optional(),
  address2CondoInsuranceCompanyAddressState: z.string().optional(),
  address2CondoInsuranceCompanyAddressZip: z.string().optional(),
  address2CondoInsurancePolicyNumber: z.string().optional(),
  address2CondoInsurancePolicyStart: DateString.optional(),
  address2CondoInsurancePolicyEnd: DateString.optional(),
  address2CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address2EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2EarthquakeInsuranceAgentName: z.string().optional(),
  address2EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address2EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address2EarthquakeInsuranceCompanyName: z.string().optional(),
  address2EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address2EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address2EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address2EarthquakeInsurancePolicyNumber: z.string().optional(),
  address2EarthquakeInsurancePolicyStart: DateString.optional(),
  address2EarthquakeInsurancePolicyEnd: DateString.optional(),
  address2EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address2UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2UmbrellaInsuranceAgentName: z.string().optional(),
  address2UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address2UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address2UmbrellaInsuranceCompanyName: z.string().optional(),
  address2UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address2UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address2UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address2UmbrellaInsurancePolicyNumber: z.string().optional(),
  address2UmbrellaInsurancePolicyStart: DateString.optional(),
  address2UmbrellaInsurancePolicyEnd: DateString.optional(),
  address2UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address2SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2SinkholeInsuranceAgentName: z.string().optional(),
  address2SinkholeInsuranceAgentEmail: OptionalEmailString,
  address2SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address2SinkholeInsuranceCompanyName: z.string().optional(),
  address2SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address2SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address2SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address2SinkholeInsurancePolicyNumber: z.string().optional(),
  address2SinkholeInsurancePolicyStart: DateString.optional(),
  address2SinkholeInsurancePolicyEnd: DateString.optional(),
  address2SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address2WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2WildfireInsuranceAgentName: z.string().optional(),
  address2WildfireInsuranceAgentEmail: OptionalEmailString,
  address2WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address2WildfireInsuranceCompanyName: z.string().optional(),
  address2WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address2WildfireInsuranceCompanyAddressState: z.string().optional(),
  address2WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address2WildfireInsurancePolicyNumber: z.string().optional(),
  address2WildfireInsurancePolicyStart: DateString.optional(),
  address2WildfireInsurancePolicyEnd: DateString.optional(),
  address2WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2SewerInsuranceIsEscrowed: Checkbox.optional(),
  address2SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2SewerInsuranceAgentName: z.string().optional(),
  address2SewerInsuranceAgentEmail: OptionalEmailString,
  address2SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address2SewerInsuranceCompanyName: z.string().optional(),
  address2SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2SewerInsuranceCompanyAddressCity: z.string().optional(),
  address2SewerInsuranceCompanyAddressState: z.string().optional(),
  address2SewerInsuranceCompanyAddressZip: z.string().optional(),
  address2SewerInsurancePolicyNumber: z.string().optional(),
  address2SewerInsurancePolicyStart: DateString.optional(),
  address2SewerInsurancePolicyEnd: DateString.optional(),
  address2SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address2EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2EquipmentInsuranceAgentName: z.string().optional(),
  address2EquipmentInsuranceAgentEmail: OptionalEmailString,
  address2EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address2EquipmentInsuranceCompanyName: z.string().optional(),
  address2EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address2EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address2EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address2EquipmentInsurancePolicyNumber: z.string().optional(),
  address2EquipmentInsurancePolicyStart: DateString.optional(),
  address2EquipmentInsurancePolicyEnd: DateString.optional(),
  address2EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2TitleInsuranceIsEscrowed: Checkbox.optional(),
  address2TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2TitleInsuranceAgentName: z.string().optional(),
  address2TitleInsuranceAgentEmail: OptionalEmailString,
  address2TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address2TitleInsuranceCompanyName: z.string().optional(),
  address2TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2TitleInsuranceCompanyAddressCity: z.string().optional(),
  address2TitleInsuranceCompanyAddressState: z.string().optional(),
  address2TitleInsuranceCompanyAddressZip: z.string().optional(),
  address2TitleInsurancePolicyNumber: z.string().optional(),
  address2TitleInsurancePolicyStart: DateString.optional(),
  address2TitleInsurancePolicyEnd: DateString.optional(),
  address2TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address2OtherInsuranceIsEscrowed: Checkbox.optional(),
  address2OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address2OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address2OtherInsuranceAgentName: z.string().optional(),
  address2OtherInsuranceAgentEmail: OptionalEmailString,
  address2OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address2OtherInsuranceCompanyName: z.string().optional(),
  address2OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address2OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address2OtherInsuranceCompanyAddressCity: z.string().optional(),
  address2OtherInsuranceCompanyAddressState: z.string().optional(),
  address2OtherInsuranceCompanyAddressZip: z.string().optional(),
  address2OtherInsurancePolicyNumber: z.string().optional(),
  address2OtherInsurancePolicyStart: DateString.optional(),
  address2OtherInsurancePolicyEnd: DateString.optional(),
  address2OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address3HazardInsuranceIsEscrowed: Checkbox.optional(),
  address3HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3HazardInsuranceAgentName: z.string().optional(),
  address3HazardInsuranceAgentEmail: OptionalEmailString,
  address3HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address3HazardInsuranceCompanyName: z.string().optional(),
  address3HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3HazardInsuranceCompanyAddressCity: z.string().optional(),
  address3HazardInsuranceCompanyAddressState: z.string().optional(),
  address3HazardInsuranceCompanyAddressZip: z.string().optional(),
  address3HazardInsurancePolicyNumber: z.string().optional(),
  address3HazardInsurancePolicyStart: DateString.optional(),
  address3HazardInsurancePolicyEnd: DateString.optional(),
  address3HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address3HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3HomeownersInsuranceAgentName: z.string().optional(),
  address3HomeownersInsuranceAgentEmail: OptionalEmailString,
  address3HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address3HomeownersInsuranceCompanyName: z.string().optional(),
  address3HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address3HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address3HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address3HomeownersInsurancePolicyNumber: z.string().optional(),
  address3HomeownersInsurancePolicyStart: DateString.optional(),
  address3HomeownersInsurancePolicyEnd: DateString.optional(),
  address3HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3FloodInsuranceIsEscrowed: Checkbox.optional(),
  address3FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3FloodInsuranceAgentName: z.string().optional(),
  address3FloodInsuranceAgentEmail: OptionalEmailString,
  address3FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address3FloodInsuranceCompanyName: z.string().optional(),
  address3FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3FloodInsuranceCompanyAddressCity: z.string().optional(),
  address3FloodInsuranceCompanyAddressState: z.string().optional(),
  address3FloodInsuranceCompanyAddressZip: z.string().optional(),
  address3FloodInsurancePolicyNumber: z.string().optional(),
  address3FloodInsurancePolicyStart: DateString.optional(),
  address3FloodInsurancePolicyEnd: DateString.optional(),
  address3FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address3WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3WindstormInsuranceAgentName: z.string().optional(),
  address3WindstormInsuranceAgentEmail: OptionalEmailString,
  address3WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address3WindstormInsuranceCompanyName: z.string().optional(),
  address3WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address3WindstormInsuranceCompanyAddressState: z.string().optional(),
  address3WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address3WindstormInsurancePolicyNumber: z.string().optional(),
  address3WindstormInsurancePolicyStart: DateString.optional(),
  address3WindstormInsurancePolicyEnd: DateString.optional(),
  address3WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address3HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3HurricaneInsuranceAgentName: z.string().optional(),
  address3HurricaneInsuranceAgentEmail: OptionalEmailString,
  address3HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address3HurricaneInsuranceCompanyName: z.string().optional(),
  address3HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address3HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address3HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address3HurricaneInsurancePolicyNumber: z.string().optional(),
  address3HurricaneInsurancePolicyStart: DateString.optional(),
  address3HurricaneInsurancePolicyEnd: DateString.optional(),
  address3HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3FireInsuranceIsEscrowed: Checkbox.optional(),
  address3FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3FireInsuranceAgentName: z.string().optional(),
  address3FireInsuranceAgentEmail: OptionalEmailString,
  address3FireInsuranceAgentPhone: OptionalPhoneNumber,
  address3FireInsuranceCompanyName: z.string().optional(),
  address3FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3FireInsuranceCompanyAddressCity: z.string().optional(),
  address3FireInsuranceCompanyAddressState: z.string().optional(),
  address3FireInsuranceCompanyAddressZip: z.string().optional(),
  address3FireInsurancePolicyNumber: z.string().optional(),
  address3FireInsurancePolicyStart: DateString.optional(),
  address3FireInsurancePolicyEnd: DateString.optional(),
  address3FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address3LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3LiabilityInsuranceAgentName: z.string().optional(),
  address3LiabilityInsuranceAgentEmail: OptionalEmailString,
  address3LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address3LiabilityInsuranceCompanyName: z.string().optional(),
  address3LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address3LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address3LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address3LiabilityInsurancePolicyNumber: z.string().optional(),
  address3LiabilityInsurancePolicyStart: DateString.optional(),
  address3LiabilityInsurancePolicyEnd: DateString.optional(),
  address3LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3RentalInsuranceIsEscrowed: Checkbox.optional(),
  address3RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3RentalInsuranceAgentName: z.string().optional(),
  address3RentalInsuranceAgentEmail: OptionalEmailString,
  address3RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address3RentalInsuranceCompanyName: z.string().optional(),
  address3RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3RentalInsuranceCompanyAddressCity: z.string().optional(),
  address3RentalInsuranceCompanyAddressState: z.string().optional(),
  address3RentalInsuranceCompanyAddressZip: z.string().optional(),
  address3RentalInsurancePolicyNumber: z.string().optional(),
  address3RentalInsurancePolicyStart: DateString.optional(),
  address3RentalInsurancePolicyEnd: DateString.optional(),
  address3RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3CondoInsuranceIsEscrowed: Checkbox.optional(),
  address3CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3CondoInsuranceAgentName: z.string().optional(),
  address3CondoInsuranceAgentEmail: OptionalEmailString,
  address3CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address3CondoInsuranceCompanyName: z.string().optional(),
  address3CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3CondoInsuranceCompanyAddressCity: z.string().optional(),
  address3CondoInsuranceCompanyAddressState: z.string().optional(),
  address3CondoInsuranceCompanyAddressZip: z.string().optional(),
  address3CondoInsurancePolicyNumber: z.string().optional(),
  address3CondoInsurancePolicyStart: DateString.optional(),
  address3CondoInsurancePolicyEnd: DateString.optional(),
  address3CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address3EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3EarthquakeInsuranceAgentName: z.string().optional(),
  address3EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address3EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address3EarthquakeInsuranceCompanyName: z.string().optional(),
  address3EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address3EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address3EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address3EarthquakeInsurancePolicyNumber: z.string().optional(),
  address3EarthquakeInsurancePolicyStart: DateString.optional(),
  address3EarthquakeInsurancePolicyEnd: DateString.optional(),
  address3EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address3UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3UmbrellaInsuranceAgentName: z.string().optional(),
  address3UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address3UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address3UmbrellaInsuranceCompanyName: z.string().optional(),
  address3UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address3UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address3UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address3UmbrellaInsurancePolicyNumber: z.string().optional(),
  address3UmbrellaInsurancePolicyStart: DateString.optional(),
  address3UmbrellaInsurancePolicyEnd: DateString.optional(),
  address3UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address3SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3SinkholeInsuranceAgentName: z.string().optional(),
  address3SinkholeInsuranceAgentEmail: OptionalEmailString,
  address3SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address3SinkholeInsuranceCompanyName: z.string().optional(),
  address3SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address3SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address3SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address3SinkholeInsurancePolicyNumber: z.string().optional(),
  address3SinkholeInsurancePolicyStart: DateString.optional(),
  address3SinkholeInsurancePolicyEnd: DateString.optional(),
  address3SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address3WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3WildfireInsuranceAgentName: z.string().optional(),
  address3WildfireInsuranceAgentEmail: OptionalEmailString,
  address3WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address3WildfireInsuranceCompanyName: z.string().optional(),
  address3WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address3WildfireInsuranceCompanyAddressState: z.string().optional(),
  address3WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address3WildfireInsurancePolicyNumber: z.string().optional(),
  address3WildfireInsurancePolicyStart: DateString.optional(),
  address3WildfireInsurancePolicyEnd: DateString.optional(),
  address3WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3SewerInsuranceIsEscrowed: Checkbox.optional(),
  address3SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3SewerInsuranceAgentName: z.string().optional(),
  address3SewerInsuranceAgentEmail: OptionalEmailString,
  address3SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address3SewerInsuranceCompanyName: z.string().optional(),
  address3SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3SewerInsuranceCompanyAddressCity: z.string().optional(),
  address3SewerInsuranceCompanyAddressState: z.string().optional(),
  address3SewerInsuranceCompanyAddressZip: z.string().optional(),
  address3SewerInsurancePolicyNumber: z.string().optional(),
  address3SewerInsurancePolicyStart: DateString.optional(),
  address3SewerInsurancePolicyEnd: DateString.optional(),
  address3SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address3EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3EquipmentInsuranceAgentName: z.string().optional(),
  address3EquipmentInsuranceAgentEmail: OptionalEmailString,
  address3EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address3EquipmentInsuranceCompanyName: z.string().optional(),
  address3EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address3EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address3EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address3EquipmentInsurancePolicyNumber: z.string().optional(),
  address3EquipmentInsurancePolicyStart: DateString.optional(),
  address3EquipmentInsurancePolicyEnd: DateString.optional(),
  address3EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3TitleInsuranceIsEscrowed: Checkbox.optional(),
  address3TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3TitleInsuranceAgentName: z.string().optional(),
  address3TitleInsuranceAgentEmail: OptionalEmailString,
  address3TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address3TitleInsuranceCompanyName: z.string().optional(),
  address3TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3TitleInsuranceCompanyAddressCity: z.string().optional(),
  address3TitleInsuranceCompanyAddressState: z.string().optional(),
  address3TitleInsuranceCompanyAddressZip: z.string().optional(),
  address3TitleInsurancePolicyNumber: z.string().optional(),
  address3TitleInsurancePolicyStart: DateString.optional(),
  address3TitleInsurancePolicyEnd: DateString.optional(),
  address3TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address3OtherInsuranceIsEscrowed: Checkbox.optional(),
  address3OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address3OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address3OtherInsuranceAgentName: z.string().optional(),
  address3OtherInsuranceAgentEmail: OptionalEmailString,
  address3OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address3OtherInsuranceCompanyName: z.string().optional(),
  address3OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address3OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address3OtherInsuranceCompanyAddressCity: z.string().optional(),
  address3OtherInsuranceCompanyAddressState: z.string().optional(),
  address3OtherInsuranceCompanyAddressZip: z.string().optional(),
  address3OtherInsurancePolicyNumber: z.string().optional(),
  address3OtherInsurancePolicyStart: DateString.optional(),
  address3OtherInsurancePolicyEnd: DateString.optional(),
  address3OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address4HazardInsuranceIsEscrowed: Checkbox.optional(),
  address4HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4HazardInsuranceAgentName: z.string().optional(),
  address4HazardInsuranceAgentEmail: OptionalEmailString,
  address4HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address4HazardInsuranceCompanyName: z.string().optional(),
  address4HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4HazardInsuranceCompanyAddressCity: z.string().optional(),
  address4HazardInsuranceCompanyAddressState: z.string().optional(),
  address4HazardInsuranceCompanyAddressZip: z.string().optional(),
  address4HazardInsurancePolicyNumber: z.string().optional(),
  address4HazardInsurancePolicyStart: DateString.optional(),
  address4HazardInsurancePolicyEnd: DateString.optional(),
  address4HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address4HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4HomeownersInsuranceAgentName: z.string().optional(),
  address4HomeownersInsuranceAgentEmail: OptionalEmailString,
  address4HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address4HomeownersInsuranceCompanyName: z.string().optional(),
  address4HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address4HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address4HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address4HomeownersInsurancePolicyNumber: z.string().optional(),
  address4HomeownersInsurancePolicyStart: DateString.optional(),
  address4HomeownersInsurancePolicyEnd: DateString.optional(),
  address4HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4FloodInsuranceIsEscrowed: Checkbox.optional(),
  address4FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4FloodInsuranceAgentName: z.string().optional(),
  address4FloodInsuranceAgentEmail: OptionalEmailString,
  address4FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address4FloodInsuranceCompanyName: z.string().optional(),
  address4FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4FloodInsuranceCompanyAddressCity: z.string().optional(),
  address4FloodInsuranceCompanyAddressState: z.string().optional(),
  address4FloodInsuranceCompanyAddressZip: z.string().optional(),
  address4FloodInsurancePolicyNumber: z.string().optional(),
  address4FloodInsurancePolicyStart: DateString.optional(),
  address4FloodInsurancePolicyEnd: DateString.optional(),
  address4FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address4WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4WindstormInsuranceAgentName: z.string().optional(),
  address4WindstormInsuranceAgentEmail: OptionalEmailString,
  address4WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address4WindstormInsuranceCompanyName: z.string().optional(),
  address4WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address4WindstormInsuranceCompanyAddressState: z.string().optional(),
  address4WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address4WindstormInsurancePolicyNumber: z.string().optional(),
  address4WindstormInsurancePolicyStart: DateString.optional(),
  address4WindstormInsurancePolicyEnd: DateString.optional(),
  address4WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address4HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4HurricaneInsuranceAgentName: z.string().optional(),
  address4HurricaneInsuranceAgentEmail: OptionalEmailString,
  address4HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address4HurricaneInsuranceCompanyName: z.string().optional(),
  address4HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address4HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address4HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address4HurricaneInsurancePolicyNumber: z.string().optional(),
  address4HurricaneInsurancePolicyStart: DateString.optional(),
  address4HurricaneInsurancePolicyEnd: DateString.optional(),
  address4HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4FireInsuranceIsEscrowed: Checkbox.optional(),
  address4FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4FireInsuranceAgentName: z.string().optional(),
  address4FireInsuranceAgentEmail: OptionalEmailString,
  address4FireInsuranceAgentPhone: OptionalPhoneNumber,
  address4FireInsuranceCompanyName: z.string().optional(),
  address4FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4FireInsuranceCompanyAddressCity: z.string().optional(),
  address4FireInsuranceCompanyAddressState: z.string().optional(),
  address4FireInsuranceCompanyAddressZip: z.string().optional(),
  address4FireInsurancePolicyNumber: z.string().optional(),
  address4FireInsurancePolicyStart: DateString.optional(),
  address4FireInsurancePolicyEnd: DateString.optional(),
  address4FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address4LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4LiabilityInsuranceAgentName: z.string().optional(),
  address4LiabilityInsuranceAgentEmail: OptionalEmailString,
  address4LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address4LiabilityInsuranceCompanyName: z.string().optional(),
  address4LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address4LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address4LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address4LiabilityInsurancePolicyNumber: z.string().optional(),
  address4LiabilityInsurancePolicyStart: DateString.optional(),
  address4LiabilityInsurancePolicyEnd: DateString.optional(),
  address4LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4RentalInsuranceIsEscrowed: Checkbox.optional(),
  address4RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4RentalInsuranceAgentName: z.string().optional(),
  address4RentalInsuranceAgentEmail: OptionalEmailString,
  address4RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address4RentalInsuranceCompanyName: z.string().optional(),
  address4RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4RentalInsuranceCompanyAddressCity: z.string().optional(),
  address4RentalInsuranceCompanyAddressState: z.string().optional(),
  address4RentalInsuranceCompanyAddressZip: z.string().optional(),
  address4RentalInsurancePolicyNumber: z.string().optional(),
  address4RentalInsurancePolicyStart: DateString.optional(),
  address4RentalInsurancePolicyEnd: DateString.optional(),
  address4RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4CondoInsuranceIsEscrowed: Checkbox.optional(),
  address4CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4CondoInsuranceAgentName: z.string().optional(),
  address4CondoInsuranceAgentEmail: OptionalEmailString,
  address4CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address4CondoInsuranceCompanyName: z.string().optional(),
  address4CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4CondoInsuranceCompanyAddressCity: z.string().optional(),
  address4CondoInsuranceCompanyAddressState: z.string().optional(),
  address4CondoInsuranceCompanyAddressZip: z.string().optional(),
  address4CondoInsurancePolicyNumber: z.string().optional(),
  address4CondoInsurancePolicyStart: DateString.optional(),
  address4CondoInsurancePolicyEnd: DateString.optional(),
  address4CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address4EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4EarthquakeInsuranceAgentName: z.string().optional(),
  address4EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address4EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address4EarthquakeInsuranceCompanyName: z.string().optional(),
  address4EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address4EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address4EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address4EarthquakeInsurancePolicyNumber: z.string().optional(),
  address4EarthquakeInsurancePolicyStart: DateString.optional(),
  address4EarthquakeInsurancePolicyEnd: DateString.optional(),
  address4EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address4UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4UmbrellaInsuranceAgentName: z.string().optional(),
  address4UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address4UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address4UmbrellaInsuranceCompanyName: z.string().optional(),
  address4UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address4UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address4UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address4UmbrellaInsurancePolicyNumber: z.string().optional(),
  address4UmbrellaInsurancePolicyStart: DateString.optional(),
  address4UmbrellaInsurancePolicyEnd: DateString.optional(),
  address4UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address4SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4SinkholeInsuranceAgentName: z.string().optional(),
  address4SinkholeInsuranceAgentEmail: OptionalEmailString,
  address4SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address4SinkholeInsuranceCompanyName: z.string().optional(),
  address4SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address4SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address4SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address4SinkholeInsurancePolicyNumber: z.string().optional(),
  address4SinkholeInsurancePolicyStart: DateString.optional(),
  address4SinkholeInsurancePolicyEnd: DateString.optional(),
  address4SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address4WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4WildfireInsuranceAgentName: z.string().optional(),
  address4WildfireInsuranceAgentEmail: OptionalEmailString,
  address4WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address4WildfireInsuranceCompanyName: z.string().optional(),
  address4WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address4WildfireInsuranceCompanyAddressState: z.string().optional(),
  address4WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address4WildfireInsurancePolicyNumber: z.string().optional(),
  address4WildfireInsurancePolicyStart: DateString.optional(),
  address4WildfireInsurancePolicyEnd: DateString.optional(),
  address4WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4SewerInsuranceIsEscrowed: Checkbox.optional(),
  address4SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4SewerInsuranceAgentName: z.string().optional(),
  address4SewerInsuranceAgentEmail: OptionalEmailString,
  address4SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address4SewerInsuranceCompanyName: z.string().optional(),
  address4SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4SewerInsuranceCompanyAddressCity: z.string().optional(),
  address4SewerInsuranceCompanyAddressState: z.string().optional(),
  address4SewerInsuranceCompanyAddressZip: z.string().optional(),
  address4SewerInsurancePolicyNumber: z.string().optional(),
  address4SewerInsurancePolicyStart: DateString.optional(),
  address4SewerInsurancePolicyEnd: DateString.optional(),
  address4SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address4EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4EquipmentInsuranceAgentName: z.string().optional(),
  address4EquipmentInsuranceAgentEmail: OptionalEmailString,
  address4EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address4EquipmentInsuranceCompanyName: z.string().optional(),
  address4EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address4EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address4EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address4EquipmentInsurancePolicyNumber: z.string().optional(),
  address4EquipmentInsurancePolicyStart: DateString.optional(),
  address4EquipmentInsurancePolicyEnd: DateString.optional(),
  address4EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4TitleInsuranceIsEscrowed: Checkbox.optional(),
  address4TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4TitleInsuranceAgentName: z.string().optional(),
  address4TitleInsuranceAgentEmail: OptionalEmailString,
  address4TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address4TitleInsuranceCompanyName: z.string().optional(),
  address4TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4TitleInsuranceCompanyAddressCity: z.string().optional(),
  address4TitleInsuranceCompanyAddressState: z.string().optional(),
  address4TitleInsuranceCompanyAddressZip: z.string().optional(),
  address4TitleInsurancePolicyNumber: z.string().optional(),
  address4TitleInsurancePolicyStart: DateString.optional(),
  address4TitleInsurancePolicyEnd: DateString.optional(),
  address4TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address4OtherInsuranceIsEscrowed: Checkbox.optional(),
  address4OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address4OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address4OtherInsuranceAgentName: z.string().optional(),
  address4OtherInsuranceAgentEmail: OptionalEmailString,
  address4OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address4OtherInsuranceCompanyName: z.string().optional(),
  address4OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address4OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address4OtherInsuranceCompanyAddressCity: z.string().optional(),
  address4OtherInsuranceCompanyAddressState: z.string().optional(),
  address4OtherInsuranceCompanyAddressZip: z.string().optional(),
  address4OtherInsurancePolicyNumber: z.string().optional(),
  address4OtherInsurancePolicyStart: DateString.optional(),
  address4OtherInsurancePolicyEnd: DateString.optional(),
  address4OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address5HazardInsuranceIsEscrowed: Checkbox.optional(),
  address5HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5HazardInsuranceAgentName: z.string().optional(),
  address5HazardInsuranceAgentEmail: OptionalEmailString,
  address5HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address5HazardInsuranceCompanyName: z.string().optional(),
  address5HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5HazardInsuranceCompanyAddressCity: z.string().optional(),
  address5HazardInsuranceCompanyAddressState: z.string().optional(),
  address5HazardInsuranceCompanyAddressZip: z.string().optional(),
  address5HazardInsurancePolicyNumber: z.string().optional(),
  address5HazardInsurancePolicyStart: DateString.optional(),
  address5HazardInsurancePolicyEnd: DateString.optional(),
  address5HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address5HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5HomeownersInsuranceAgentName: z.string().optional(),
  address5HomeownersInsuranceAgentEmail: OptionalEmailString,
  address5HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address5HomeownersInsuranceCompanyName: z.string().optional(),
  address5HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address5HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address5HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address5HomeownersInsurancePolicyNumber: z.string().optional(),
  address5HomeownersInsurancePolicyStart: DateString.optional(),
  address5HomeownersInsurancePolicyEnd: DateString.optional(),
  address5HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5FloodInsuranceIsEscrowed: Checkbox.optional(),
  address5FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5FloodInsuranceAgentName: z.string().optional(),
  address5FloodInsuranceAgentEmail: OptionalEmailString,
  address5FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address5FloodInsuranceCompanyName: z.string().optional(),
  address5FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5FloodInsuranceCompanyAddressCity: z.string().optional(),
  address5FloodInsuranceCompanyAddressState: z.string().optional(),
  address5FloodInsuranceCompanyAddressZip: z.string().optional(),
  address5FloodInsurancePolicyNumber: z.string().optional(),
  address5FloodInsurancePolicyStart: DateString.optional(),
  address5FloodInsurancePolicyEnd: DateString.optional(),
  address5FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address5WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5WindstormInsuranceAgentName: z.string().optional(),
  address5WindstormInsuranceAgentEmail: OptionalEmailString,
  address5WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address5WindstormInsuranceCompanyName: z.string().optional(),
  address5WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address5WindstormInsuranceCompanyAddressState: z.string().optional(),
  address5WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address5WindstormInsurancePolicyNumber: z.string().optional(),
  address5WindstormInsurancePolicyStart: DateString.optional(),
  address5WindstormInsurancePolicyEnd: DateString.optional(),
  address5WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address5HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5HurricaneInsuranceAgentName: z.string().optional(),
  address5HurricaneInsuranceAgentEmail: OptionalEmailString,
  address5HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address5HurricaneInsuranceCompanyName: z.string().optional(),
  address5HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address5HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address5HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address5HurricaneInsurancePolicyNumber: z.string().optional(),
  address5HurricaneInsurancePolicyStart: DateString.optional(),
  address5HurricaneInsurancePolicyEnd: DateString.optional(),
  address5HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5FireInsuranceIsEscrowed: Checkbox.optional(),
  address5FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5FireInsuranceAgentName: z.string().optional(),
  address5FireInsuranceAgentEmail: OptionalEmailString,
  address5FireInsuranceAgentPhone: OptionalPhoneNumber,
  address5FireInsuranceCompanyName: z.string().optional(),
  address5FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5FireInsuranceCompanyAddressCity: z.string().optional(),
  address5FireInsuranceCompanyAddressState: z.string().optional(),
  address5FireInsuranceCompanyAddressZip: z.string().optional(),
  address5FireInsurancePolicyNumber: z.string().optional(),
  address5FireInsurancePolicyStart: DateString.optional(),
  address5FireInsurancePolicyEnd: DateString.optional(),
  address5FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address5LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5LiabilityInsuranceAgentName: z.string().optional(),
  address5LiabilityInsuranceAgentEmail: OptionalEmailString,
  address5LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address5LiabilityInsuranceCompanyName: z.string().optional(),
  address5LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address5LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address5LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address5LiabilityInsurancePolicyNumber: z.string().optional(),
  address5LiabilityInsurancePolicyStart: DateString.optional(),
  address5LiabilityInsurancePolicyEnd: DateString.optional(),
  address5LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5RentalInsuranceIsEscrowed: Checkbox.optional(),
  address5RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5RentalInsuranceAgentName: z.string().optional(),
  address5RentalInsuranceAgentEmail: OptionalEmailString,
  address5RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address5RentalInsuranceCompanyName: z.string().optional(),
  address5RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5RentalInsuranceCompanyAddressCity: z.string().optional(),
  address5RentalInsuranceCompanyAddressState: z.string().optional(),
  address5RentalInsuranceCompanyAddressZip: z.string().optional(),
  address5RentalInsurancePolicyNumber: z.string().optional(),
  address5RentalInsurancePolicyStart: DateString.optional(),
  address5RentalInsurancePolicyEnd: DateString.optional(),
  address5RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5CondoInsuranceIsEscrowed: Checkbox.optional(),
  address5CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5CondoInsuranceAgentName: z.string().optional(),
  address5CondoInsuranceAgentEmail: OptionalEmailString,
  address5CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address5CondoInsuranceCompanyName: z.string().optional(),
  address5CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5CondoInsuranceCompanyAddressCity: z.string().optional(),
  address5CondoInsuranceCompanyAddressState: z.string().optional(),
  address5CondoInsuranceCompanyAddressZip: z.string().optional(),
  address5CondoInsurancePolicyNumber: z.string().optional(),
  address5CondoInsurancePolicyStart: DateString.optional(),
  address5CondoInsurancePolicyEnd: DateString.optional(),
  address5CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address5EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5EarthquakeInsuranceAgentName: z.string().optional(),
  address5EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address5EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address5EarthquakeInsuranceCompanyName: z.string().optional(),
  address5EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address5EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address5EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address5EarthquakeInsurancePolicyNumber: z.string().optional(),
  address5EarthquakeInsurancePolicyStart: DateString.optional(),
  address5EarthquakeInsurancePolicyEnd: DateString.optional(),
  address5EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address5UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5UmbrellaInsuranceAgentName: z.string().optional(),
  address5UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address5UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address5UmbrellaInsuranceCompanyName: z.string().optional(),
  address5UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address5UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address5UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address5UmbrellaInsurancePolicyNumber: z.string().optional(),
  address5UmbrellaInsurancePolicyStart: DateString.optional(),
  address5UmbrellaInsurancePolicyEnd: DateString.optional(),
  address5UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address5SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5SinkholeInsuranceAgentName: z.string().optional(),
  address5SinkholeInsuranceAgentEmail: OptionalEmailString,
  address5SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address5SinkholeInsuranceCompanyName: z.string().optional(),
  address5SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address5SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address5SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address5SinkholeInsurancePolicyNumber: z.string().optional(),
  address5SinkholeInsurancePolicyStart: DateString.optional(),
  address5SinkholeInsurancePolicyEnd: DateString.optional(),
  address5SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address5WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5WildfireInsuranceAgentName: z.string().optional(),
  address5WildfireInsuranceAgentEmail: OptionalEmailString,
  address5WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address5WildfireInsuranceCompanyName: z.string().optional(),
  address5WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address5WildfireInsuranceCompanyAddressState: z.string().optional(),
  address5WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address5WildfireInsurancePolicyNumber: z.string().optional(),
  address5WildfireInsurancePolicyStart: DateString.optional(),
  address5WildfireInsurancePolicyEnd: DateString.optional(),
  address5WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5SewerInsuranceIsEscrowed: Checkbox.optional(),
  address5SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5SewerInsuranceAgentName: z.string().optional(),
  address5SewerInsuranceAgentEmail: OptionalEmailString,
  address5SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address5SewerInsuranceCompanyName: z.string().optional(),
  address5SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5SewerInsuranceCompanyAddressCity: z.string().optional(),
  address5SewerInsuranceCompanyAddressState: z.string().optional(),
  address5SewerInsuranceCompanyAddressZip: z.string().optional(),
  address5SewerInsurancePolicyNumber: z.string().optional(),
  address5SewerInsurancePolicyStart: DateString.optional(),
  address5SewerInsurancePolicyEnd: DateString.optional(),
  address5SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address5EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5EquipmentInsuranceAgentName: z.string().optional(),
  address5EquipmentInsuranceAgentEmail: OptionalEmailString,
  address5EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address5EquipmentInsuranceCompanyName: z.string().optional(),
  address5EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address5EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address5EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address5EquipmentInsurancePolicyNumber: z.string().optional(),
  address5EquipmentInsurancePolicyStart: DateString.optional(),
  address5EquipmentInsurancePolicyEnd: DateString.optional(),
  address5EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5TitleInsuranceIsEscrowed: Checkbox.optional(),
  address5TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5TitleInsuranceAgentName: z.string().optional(),
  address5TitleInsuranceAgentEmail: OptionalEmailString,
  address5TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address5TitleInsuranceCompanyName: z.string().optional(),
  address5TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5TitleInsuranceCompanyAddressCity: z.string().optional(),
  address5TitleInsuranceCompanyAddressState: z.string().optional(),
  address5TitleInsuranceCompanyAddressZip: z.string().optional(),
  address5TitleInsurancePolicyNumber: z.string().optional(),
  address5TitleInsurancePolicyStart: DateString.optional(),
  address5TitleInsurancePolicyEnd: DateString.optional(),
  address5TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address5OtherInsuranceIsEscrowed: Checkbox.optional(),
  address5OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address5OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address5OtherInsuranceAgentName: z.string().optional(),
  address5OtherInsuranceAgentEmail: OptionalEmailString,
  address5OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address5OtherInsuranceCompanyName: z.string().optional(),
  address5OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address5OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address5OtherInsuranceCompanyAddressCity: z.string().optional(),
  address5OtherInsuranceCompanyAddressState: z.string().optional(),
  address5OtherInsuranceCompanyAddressZip: z.string().optional(),
  address5OtherInsurancePolicyNumber: z.string().optional(),
  address5OtherInsurancePolicyStart: DateString.optional(),
  address5OtherInsurancePolicyEnd: DateString.optional(),
  address5OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address6HazardInsuranceIsEscrowed: Checkbox.optional(),
  address6HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6HazardInsuranceAgentName: z.string().optional(),
  address6HazardInsuranceAgentEmail: OptionalEmailString,
  address6HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address6HazardInsuranceCompanyName: z.string().optional(),
  address6HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6HazardInsuranceCompanyAddressCity: z.string().optional(),
  address6HazardInsuranceCompanyAddressState: z.string().optional(),
  address6HazardInsuranceCompanyAddressZip: z.string().optional(),
  address6HazardInsurancePolicyNumber: z.string().optional(),
  address6HazardInsurancePolicyStart: DateString.optional(),
  address6HazardInsurancePolicyEnd: DateString.optional(),
  address6HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address6HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6HomeownersInsuranceAgentName: z.string().optional(),
  address6HomeownersInsuranceAgentEmail: OptionalEmailString,
  address6HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address6HomeownersInsuranceCompanyName: z.string().optional(),
  address6HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address6HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address6HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address6HomeownersInsurancePolicyNumber: z.string().optional(),
  address6HomeownersInsurancePolicyStart: DateString.optional(),
  address6HomeownersInsurancePolicyEnd: DateString.optional(),
  address6HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6FloodInsuranceIsEscrowed: Checkbox.optional(),
  address6FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6FloodInsuranceAgentName: z.string().optional(),
  address6FloodInsuranceAgentEmail: OptionalEmailString,
  address6FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address6FloodInsuranceCompanyName: z.string().optional(),
  address6FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6FloodInsuranceCompanyAddressCity: z.string().optional(),
  address6FloodInsuranceCompanyAddressState: z.string().optional(),
  address6FloodInsuranceCompanyAddressZip: z.string().optional(),
  address6FloodInsurancePolicyNumber: z.string().optional(),
  address6FloodInsurancePolicyStart: DateString.optional(),
  address6FloodInsurancePolicyEnd: DateString.optional(),
  address6FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address6WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6WindstormInsuranceAgentName: z.string().optional(),
  address6WindstormInsuranceAgentEmail: OptionalEmailString,
  address6WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address6WindstormInsuranceCompanyName: z.string().optional(),
  address6WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address6WindstormInsuranceCompanyAddressState: z.string().optional(),
  address6WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address6WindstormInsurancePolicyNumber: z.string().optional(),
  address6WindstormInsurancePolicyStart: DateString.optional(),
  address6WindstormInsurancePolicyEnd: DateString.optional(),
  address6WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address6HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6HurricaneInsuranceAgentName: z.string().optional(),
  address6HurricaneInsuranceAgentEmail: OptionalEmailString,
  address6HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address6HurricaneInsuranceCompanyName: z.string().optional(),
  address6HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address6HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address6HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address6HurricaneInsurancePolicyNumber: z.string().optional(),
  address6HurricaneInsurancePolicyStart: DateString.optional(),
  address6HurricaneInsurancePolicyEnd: DateString.optional(),
  address6HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6FireInsuranceIsEscrowed: Checkbox.optional(),
  address6FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6FireInsuranceAgentName: z.string().optional(),
  address6FireInsuranceAgentEmail: OptionalEmailString,
  address6FireInsuranceAgentPhone: OptionalPhoneNumber,
  address6FireInsuranceCompanyName: z.string().optional(),
  address6FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6FireInsuranceCompanyAddressCity: z.string().optional(),
  address6FireInsuranceCompanyAddressState: z.string().optional(),
  address6FireInsuranceCompanyAddressZip: z.string().optional(),
  address6FireInsurancePolicyNumber: z.string().optional(),
  address6FireInsurancePolicyStart: DateString.optional(),
  address6FireInsurancePolicyEnd: DateString.optional(),
  address6FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address6LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6LiabilityInsuranceAgentName: z.string().optional(),
  address6LiabilityInsuranceAgentEmail: OptionalEmailString,
  address6LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address6LiabilityInsuranceCompanyName: z.string().optional(),
  address6LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address6LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address6LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address6LiabilityInsurancePolicyNumber: z.string().optional(),
  address6LiabilityInsurancePolicyStart: DateString.optional(),
  address6LiabilityInsurancePolicyEnd: DateString.optional(),
  address6LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6RentalInsuranceIsEscrowed: Checkbox.optional(),
  address6RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6RentalInsuranceAgentName: z.string().optional(),
  address6RentalInsuranceAgentEmail: OptionalEmailString,
  address6RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address6RentalInsuranceCompanyName: z.string().optional(),
  address6RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6RentalInsuranceCompanyAddressCity: z.string().optional(),
  address6RentalInsuranceCompanyAddressState: z.string().optional(),
  address6RentalInsuranceCompanyAddressZip: z.string().optional(),
  address6RentalInsurancePolicyNumber: z.string().optional(),
  address6RentalInsurancePolicyStart: DateString.optional(),
  address6RentalInsurancePolicyEnd: DateString.optional(),
  address6RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6CondoInsuranceIsEscrowed: Checkbox.optional(),
  address6CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6CondoInsuranceAgentName: z.string().optional(),
  address6CondoInsuranceAgentEmail: OptionalEmailString,
  address6CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address6CondoInsuranceCompanyName: z.string().optional(),
  address6CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6CondoInsuranceCompanyAddressCity: z.string().optional(),
  address6CondoInsuranceCompanyAddressState: z.string().optional(),
  address6CondoInsuranceCompanyAddressZip: z.string().optional(),
  address6CondoInsurancePolicyNumber: z.string().optional(),
  address6CondoInsurancePolicyStart: DateString.optional(),
  address6CondoInsurancePolicyEnd: DateString.optional(),
  address6CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address6EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6EarthquakeInsuranceAgentName: z.string().optional(),
  address6EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address6EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address6EarthquakeInsuranceCompanyName: z.string().optional(),
  address6EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address6EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address6EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address6EarthquakeInsurancePolicyNumber: z.string().optional(),
  address6EarthquakeInsurancePolicyStart: DateString.optional(),
  address6EarthquakeInsurancePolicyEnd: DateString.optional(),
  address6EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address6UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6UmbrellaInsuranceAgentName: z.string().optional(),
  address6UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address6UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address6UmbrellaInsuranceCompanyName: z.string().optional(),
  address6UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address6UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address6UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address6UmbrellaInsurancePolicyNumber: z.string().optional(),
  address6UmbrellaInsurancePolicyStart: DateString.optional(),
  address6UmbrellaInsurancePolicyEnd: DateString.optional(),
  address6UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address6SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6SinkholeInsuranceAgentName: z.string().optional(),
  address6SinkholeInsuranceAgentEmail: OptionalEmailString,
  address6SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address6SinkholeInsuranceCompanyName: z.string().optional(),
  address6SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address6SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address6SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address6SinkholeInsurancePolicyNumber: z.string().optional(),
  address6SinkholeInsurancePolicyStart: DateString.optional(),
  address6SinkholeInsurancePolicyEnd: DateString.optional(),
  address6SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address6WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6WildfireInsuranceAgentName: z.string().optional(),
  address6WildfireInsuranceAgentEmail: OptionalEmailString,
  address6WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address6WildfireInsuranceCompanyName: z.string().optional(),
  address6WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address6WildfireInsuranceCompanyAddressState: z.string().optional(),
  address6WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address6WildfireInsurancePolicyNumber: z.string().optional(),
  address6WildfireInsurancePolicyStart: DateString.optional(),
  address6WildfireInsurancePolicyEnd: DateString.optional(),
  address6WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6SewerInsuranceIsEscrowed: Checkbox.optional(),
  address6SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6SewerInsuranceAgentName: z.string().optional(),
  address6SewerInsuranceAgentEmail: OptionalEmailString,
  address6SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address6SewerInsuranceCompanyName: z.string().optional(),
  address6SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6SewerInsuranceCompanyAddressCity: z.string().optional(),
  address6SewerInsuranceCompanyAddressState: z.string().optional(),
  address6SewerInsuranceCompanyAddressZip: z.string().optional(),
  address6SewerInsurancePolicyNumber: z.string().optional(),
  address6SewerInsurancePolicyStart: DateString.optional(),
  address6SewerInsurancePolicyEnd: DateString.optional(),
  address6SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address6EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6EquipmentInsuranceAgentName: z.string().optional(),
  address6EquipmentInsuranceAgentEmail: OptionalEmailString,
  address6EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address6EquipmentInsuranceCompanyName: z.string().optional(),
  address6EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address6EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address6EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address6EquipmentInsurancePolicyNumber: z.string().optional(),
  address6EquipmentInsurancePolicyStart: DateString.optional(),
  address6EquipmentInsurancePolicyEnd: DateString.optional(),
  address6EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6TitleInsuranceIsEscrowed: Checkbox.optional(),
  address6TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6TitleInsuranceAgentName: z.string().optional(),
  address6TitleInsuranceAgentEmail: OptionalEmailString,
  address6TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address6TitleInsuranceCompanyName: z.string().optional(),
  address6TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6TitleInsuranceCompanyAddressCity: z.string().optional(),
  address6TitleInsuranceCompanyAddressState: z.string().optional(),
  address6TitleInsuranceCompanyAddressZip: z.string().optional(),
  address6TitleInsurancePolicyNumber: z.string().optional(),
  address6TitleInsurancePolicyStart: DateString.optional(),
  address6TitleInsurancePolicyEnd: DateString.optional(),
  address6TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address6OtherInsuranceIsEscrowed: Checkbox.optional(),
  address6OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address6OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address6OtherInsuranceAgentName: z.string().optional(),
  address6OtherInsuranceAgentEmail: OptionalEmailString,
  address6OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address6OtherInsuranceCompanyName: z.string().optional(),
  address6OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address6OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address6OtherInsuranceCompanyAddressCity: z.string().optional(),
  address6OtherInsuranceCompanyAddressState: z.string().optional(),
  address6OtherInsuranceCompanyAddressZip: z.string().optional(),
  address6OtherInsurancePolicyNumber: z.string().optional(),
  address6OtherInsurancePolicyStart: DateString.optional(),
  address6OtherInsurancePolicyEnd: DateString.optional(),
  address6OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address7HazardInsuranceIsEscrowed: Checkbox.optional(),
  address7HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7HazardInsuranceAgentName: z.string().optional(),
  address7HazardInsuranceAgentEmail: OptionalEmailString,
  address7HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address7HazardInsuranceCompanyName: z.string().optional(),
  address7HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7HazardInsuranceCompanyAddressCity: z.string().optional(),
  address7HazardInsuranceCompanyAddressState: z.string().optional(),
  address7HazardInsuranceCompanyAddressZip: z.string().optional(),
  address7HazardInsurancePolicyNumber: z.string().optional(),
  address7HazardInsurancePolicyStart: DateString.optional(),
  address7HazardInsurancePolicyEnd: DateString.optional(),
  address7HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address7HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7HomeownersInsuranceAgentName: z.string().optional(),
  address7HomeownersInsuranceAgentEmail: OptionalEmailString,
  address7HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address7HomeownersInsuranceCompanyName: z.string().optional(),
  address7HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address7HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address7HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address7HomeownersInsurancePolicyNumber: z.string().optional(),
  address7HomeownersInsurancePolicyStart: DateString.optional(),
  address7HomeownersInsurancePolicyEnd: DateString.optional(),
  address7HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7FloodInsuranceIsEscrowed: Checkbox.optional(),
  address7FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7FloodInsuranceAgentName: z.string().optional(),
  address7FloodInsuranceAgentEmail: OptionalEmailString,
  address7FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address7FloodInsuranceCompanyName: z.string().optional(),
  address7FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7FloodInsuranceCompanyAddressCity: z.string().optional(),
  address7FloodInsuranceCompanyAddressState: z.string().optional(),
  address7FloodInsuranceCompanyAddressZip: z.string().optional(),
  address7FloodInsurancePolicyNumber: z.string().optional(),
  address7FloodInsurancePolicyStart: DateString.optional(),
  address7FloodInsurancePolicyEnd: DateString.optional(),
  address7FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address7WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7WindstormInsuranceAgentName: z.string().optional(),
  address7WindstormInsuranceAgentEmail: OptionalEmailString,
  address7WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address7WindstormInsuranceCompanyName: z.string().optional(),
  address7WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address7WindstormInsuranceCompanyAddressState: z.string().optional(),
  address7WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address7WindstormInsurancePolicyNumber: z.string().optional(),
  address7WindstormInsurancePolicyStart: DateString.optional(),
  address7WindstormInsurancePolicyEnd: DateString.optional(),
  address7WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address7HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7HurricaneInsuranceAgentName: z.string().optional(),
  address7HurricaneInsuranceAgentEmail: OptionalEmailString,
  address7HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address7HurricaneInsuranceCompanyName: z.string().optional(),
  address7HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address7HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address7HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address7HurricaneInsurancePolicyNumber: z.string().optional(),
  address7HurricaneInsurancePolicyStart: DateString.optional(),
  address7HurricaneInsurancePolicyEnd: DateString.optional(),
  address7HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7FireInsuranceIsEscrowed: Checkbox.optional(),
  address7FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7FireInsuranceAgentName: z.string().optional(),
  address7FireInsuranceAgentEmail: OptionalEmailString,
  address7FireInsuranceAgentPhone: OptionalPhoneNumber,
  address7FireInsuranceCompanyName: z.string().optional(),
  address7FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7FireInsuranceCompanyAddressCity: z.string().optional(),
  address7FireInsuranceCompanyAddressState: z.string().optional(),
  address7FireInsuranceCompanyAddressZip: z.string().optional(),
  address7FireInsurancePolicyNumber: z.string().optional(),
  address7FireInsurancePolicyStart: DateString.optional(),
  address7FireInsurancePolicyEnd: DateString.optional(),
  address7FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address7LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7LiabilityInsuranceAgentName: z.string().optional(),
  address7LiabilityInsuranceAgentEmail: OptionalEmailString,
  address7LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address7LiabilityInsuranceCompanyName: z.string().optional(),
  address7LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address7LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address7LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address7LiabilityInsurancePolicyNumber: z.string().optional(),
  address7LiabilityInsurancePolicyStart: DateString.optional(),
  address7LiabilityInsurancePolicyEnd: DateString.optional(),
  address7LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7RentalInsuranceIsEscrowed: Checkbox.optional(),
  address7RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7RentalInsuranceAgentName: z.string().optional(),
  address7RentalInsuranceAgentEmail: OptionalEmailString,
  address7RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address7RentalInsuranceCompanyName: z.string().optional(),
  address7RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7RentalInsuranceCompanyAddressCity: z.string().optional(),
  address7RentalInsuranceCompanyAddressState: z.string().optional(),
  address7RentalInsuranceCompanyAddressZip: z.string().optional(),
  address7RentalInsurancePolicyNumber: z.string().optional(),
  address7RentalInsurancePolicyStart: DateString.optional(),
  address7RentalInsurancePolicyEnd: DateString.optional(),
  address7RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7CondoInsuranceIsEscrowed: Checkbox.optional(),
  address7CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7CondoInsuranceAgentName: z.string().optional(),
  address7CondoInsuranceAgentEmail: OptionalEmailString,
  address7CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address7CondoInsuranceCompanyName: z.string().optional(),
  address7CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7CondoInsuranceCompanyAddressCity: z.string().optional(),
  address7CondoInsuranceCompanyAddressState: z.string().optional(),
  address7CondoInsuranceCompanyAddressZip: z.string().optional(),
  address7CondoInsurancePolicyNumber: z.string().optional(),
  address7CondoInsurancePolicyStart: DateString.optional(),
  address7CondoInsurancePolicyEnd: DateString.optional(),
  address7CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address7EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7EarthquakeInsuranceAgentName: z.string().optional(),
  address7EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address7EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address7EarthquakeInsuranceCompanyName: z.string().optional(),
  address7EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address7EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address7EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address7EarthquakeInsurancePolicyNumber: z.string().optional(),
  address7EarthquakeInsurancePolicyStart: DateString.optional(),
  address7EarthquakeInsurancePolicyEnd: DateString.optional(),
  address7EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address7UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7UmbrellaInsuranceAgentName: z.string().optional(),
  address7UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address7UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address7UmbrellaInsuranceCompanyName: z.string().optional(),
  address7UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address7UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address7UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address7UmbrellaInsurancePolicyNumber: z.string().optional(),
  address7UmbrellaInsurancePolicyStart: DateString.optional(),
  address7UmbrellaInsurancePolicyEnd: DateString.optional(),
  address7UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address7SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7SinkholeInsuranceAgentName: z.string().optional(),
  address7SinkholeInsuranceAgentEmail: OptionalEmailString,
  address7SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address7SinkholeInsuranceCompanyName: z.string().optional(),
  address7SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address7SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address7SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address7SinkholeInsurancePolicyNumber: z.string().optional(),
  address7SinkholeInsurancePolicyStart: DateString.optional(),
  address7SinkholeInsurancePolicyEnd: DateString.optional(),
  address7SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address7WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7WildfireInsuranceAgentName: z.string().optional(),
  address7WildfireInsuranceAgentEmail: OptionalEmailString,
  address7WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address7WildfireInsuranceCompanyName: z.string().optional(),
  address7WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address7WildfireInsuranceCompanyAddressState: z.string().optional(),
  address7WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address7WildfireInsurancePolicyNumber: z.string().optional(),
  address7WildfireInsurancePolicyStart: DateString.optional(),
  address7WildfireInsurancePolicyEnd: DateString.optional(),
  address7WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7SewerInsuranceIsEscrowed: Checkbox.optional(),
  address7SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7SewerInsuranceAgentName: z.string().optional(),
  address7SewerInsuranceAgentEmail: OptionalEmailString,
  address7SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address7SewerInsuranceCompanyName: z.string().optional(),
  address7SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7SewerInsuranceCompanyAddressCity: z.string().optional(),
  address7SewerInsuranceCompanyAddressState: z.string().optional(),
  address7SewerInsuranceCompanyAddressZip: z.string().optional(),
  address7SewerInsurancePolicyNumber: z.string().optional(),
  address7SewerInsurancePolicyStart: DateString.optional(),
  address7SewerInsurancePolicyEnd: DateString.optional(),
  address7SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address7EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7EquipmentInsuranceAgentName: z.string().optional(),
  address7EquipmentInsuranceAgentEmail: OptionalEmailString,
  address7EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address7EquipmentInsuranceCompanyName: z.string().optional(),
  address7EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address7EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address7EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address7EquipmentInsurancePolicyNumber: z.string().optional(),
  address7EquipmentInsurancePolicyStart: DateString.optional(),
  address7EquipmentInsurancePolicyEnd: DateString.optional(),
  address7EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7TitleInsuranceIsEscrowed: Checkbox.optional(),
  address7TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7TitleInsuranceAgentName: z.string().optional(),
  address7TitleInsuranceAgentEmail: OptionalEmailString,
  address7TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address7TitleInsuranceCompanyName: z.string().optional(),
  address7TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7TitleInsuranceCompanyAddressCity: z.string().optional(),
  address7TitleInsuranceCompanyAddressState: z.string().optional(),
  address7TitleInsuranceCompanyAddressZip: z.string().optional(),
  address7TitleInsurancePolicyNumber: z.string().optional(),
  address7TitleInsurancePolicyStart: DateString.optional(),
  address7TitleInsurancePolicyEnd: DateString.optional(),
  address7TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address7OtherInsuranceIsEscrowed: Checkbox.optional(),
  address7OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address7OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address7OtherInsuranceAgentName: z.string().optional(),
  address7OtherInsuranceAgentEmail: OptionalEmailString,
  address7OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address7OtherInsuranceCompanyName: z.string().optional(),
  address7OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address7OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address7OtherInsuranceCompanyAddressCity: z.string().optional(),
  address7OtherInsuranceCompanyAddressState: z.string().optional(),
  address7OtherInsuranceCompanyAddressZip: z.string().optional(),
  address7OtherInsurancePolicyNumber: z.string().optional(),
  address7OtherInsurancePolicyStart: DateString.optional(),
  address7OtherInsurancePolicyEnd: DateString.optional(),
  address7OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address8HazardInsuranceIsEscrowed: Checkbox.optional(),
  address8HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8HazardInsuranceAgentName: z.string().optional(),
  address8HazardInsuranceAgentEmail: OptionalEmailString,
  address8HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address8HazardInsuranceCompanyName: z.string().optional(),
  address8HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8HazardInsuranceCompanyAddressCity: z.string().optional(),
  address8HazardInsuranceCompanyAddressState: z.string().optional(),
  address8HazardInsuranceCompanyAddressZip: z.string().optional(),
  address8HazardInsurancePolicyNumber: z.string().optional(),
  address8HazardInsurancePolicyStart: DateString.optional(),
  address8HazardInsurancePolicyEnd: DateString.optional(),
  address8HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address8HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8HomeownersInsuranceAgentName: z.string().optional(),
  address8HomeownersInsuranceAgentEmail: OptionalEmailString,
  address8HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address8HomeownersInsuranceCompanyName: z.string().optional(),
  address8HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address8HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address8HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address8HomeownersInsurancePolicyNumber: z.string().optional(),
  address8HomeownersInsurancePolicyStart: DateString.optional(),
  address8HomeownersInsurancePolicyEnd: DateString.optional(),
  address8HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8FloodInsuranceIsEscrowed: Checkbox.optional(),
  address8FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8FloodInsuranceAgentName: z.string().optional(),
  address8FloodInsuranceAgentEmail: OptionalEmailString,
  address8FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address8FloodInsuranceCompanyName: z.string().optional(),
  address8FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8FloodInsuranceCompanyAddressCity: z.string().optional(),
  address8FloodInsuranceCompanyAddressState: z.string().optional(),
  address8FloodInsuranceCompanyAddressZip: z.string().optional(),
  address8FloodInsurancePolicyNumber: z.string().optional(),
  address8FloodInsurancePolicyStart: DateString.optional(),
  address8FloodInsurancePolicyEnd: DateString.optional(),
  address8FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address8WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8WindstormInsuranceAgentName: z.string().optional(),
  address8WindstormInsuranceAgentEmail: OptionalEmailString,
  address8WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address8WindstormInsuranceCompanyName: z.string().optional(),
  address8WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address8WindstormInsuranceCompanyAddressState: z.string().optional(),
  address8WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address8WindstormInsurancePolicyNumber: z.string().optional(),
  address8WindstormInsurancePolicyStart: DateString.optional(),
  address8WindstormInsurancePolicyEnd: DateString.optional(),
  address8WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address8HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8HurricaneInsuranceAgentName: z.string().optional(),
  address8HurricaneInsuranceAgentEmail: OptionalEmailString,
  address8HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address8HurricaneInsuranceCompanyName: z.string().optional(),
  address8HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address8HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address8HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address8HurricaneInsurancePolicyNumber: z.string().optional(),
  address8HurricaneInsurancePolicyStart: DateString.optional(),
  address8HurricaneInsurancePolicyEnd: DateString.optional(),
  address8HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8FireInsuranceIsEscrowed: Checkbox.optional(),
  address8FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8FireInsuranceAgentName: z.string().optional(),
  address8FireInsuranceAgentEmail: OptionalEmailString,
  address8FireInsuranceAgentPhone: OptionalPhoneNumber,
  address8FireInsuranceCompanyName: z.string().optional(),
  address8FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8FireInsuranceCompanyAddressCity: z.string().optional(),
  address8FireInsuranceCompanyAddressState: z.string().optional(),
  address8FireInsuranceCompanyAddressZip: z.string().optional(),
  address8FireInsurancePolicyNumber: z.string().optional(),
  address8FireInsurancePolicyStart: DateString.optional(),
  address8FireInsurancePolicyEnd: DateString.optional(),
  address8FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address8LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8LiabilityInsuranceAgentName: z.string().optional(),
  address8LiabilityInsuranceAgentEmail: OptionalEmailString,
  address8LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address8LiabilityInsuranceCompanyName: z.string().optional(),
  address8LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address8LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address8LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address8LiabilityInsurancePolicyNumber: z.string().optional(),
  address8LiabilityInsurancePolicyStart: DateString.optional(),
  address8LiabilityInsurancePolicyEnd: DateString.optional(),
  address8LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8RentalInsuranceIsEscrowed: Checkbox.optional(),
  address8RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8RentalInsuranceAgentName: z.string().optional(),
  address8RentalInsuranceAgentEmail: OptionalEmailString,
  address8RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address8RentalInsuranceCompanyName: z.string().optional(),
  address8RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8RentalInsuranceCompanyAddressCity: z.string().optional(),
  address8RentalInsuranceCompanyAddressState: z.string().optional(),
  address8RentalInsuranceCompanyAddressZip: z.string().optional(),
  address8RentalInsurancePolicyNumber: z.string().optional(),
  address8RentalInsurancePolicyStart: DateString.optional(),
  address8RentalInsurancePolicyEnd: DateString.optional(),
  address8RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8CondoInsuranceIsEscrowed: Checkbox.optional(),
  address8CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8CondoInsuranceAgentName: z.string().optional(),
  address8CondoInsuranceAgentEmail: OptionalEmailString,
  address8CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address8CondoInsuranceCompanyName: z.string().optional(),
  address8CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8CondoInsuranceCompanyAddressCity: z.string().optional(),
  address8CondoInsuranceCompanyAddressState: z.string().optional(),
  address8CondoInsuranceCompanyAddressZip: z.string().optional(),
  address8CondoInsurancePolicyNumber: z.string().optional(),
  address8CondoInsurancePolicyStart: DateString.optional(),
  address8CondoInsurancePolicyEnd: DateString.optional(),
  address8CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address8EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8EarthquakeInsuranceAgentName: z.string().optional(),
  address8EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address8EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address8EarthquakeInsuranceCompanyName: z.string().optional(),
  address8EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address8EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address8EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address8EarthquakeInsurancePolicyNumber: z.string().optional(),
  address8EarthquakeInsurancePolicyStart: DateString.optional(),
  address8EarthquakeInsurancePolicyEnd: DateString.optional(),
  address8EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address8UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8UmbrellaInsuranceAgentName: z.string().optional(),
  address8UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address8UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address8UmbrellaInsuranceCompanyName: z.string().optional(),
  address8UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address8UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address8UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address8UmbrellaInsurancePolicyNumber: z.string().optional(),
  address8UmbrellaInsurancePolicyStart: DateString.optional(),
  address8UmbrellaInsurancePolicyEnd: DateString.optional(),
  address8UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address8SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8SinkholeInsuranceAgentName: z.string().optional(),
  address8SinkholeInsuranceAgentEmail: OptionalEmailString,
  address8SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address8SinkholeInsuranceCompanyName: z.string().optional(),
  address8SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address8SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address8SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address8SinkholeInsurancePolicyNumber: z.string().optional(),
  address8SinkholeInsurancePolicyStart: DateString.optional(),
  address8SinkholeInsurancePolicyEnd: DateString.optional(),
  address8SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address8WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8WildfireInsuranceAgentName: z.string().optional(),
  address8WildfireInsuranceAgentEmail: OptionalEmailString,
  address8WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address8WildfireInsuranceCompanyName: z.string().optional(),
  address8WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address8WildfireInsuranceCompanyAddressState: z.string().optional(),
  address8WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address8WildfireInsurancePolicyNumber: z.string().optional(),
  address8WildfireInsurancePolicyStart: DateString.optional(),
  address8WildfireInsurancePolicyEnd: DateString.optional(),
  address8WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8SewerInsuranceIsEscrowed: Checkbox.optional(),
  address8SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8SewerInsuranceAgentName: z.string().optional(),
  address8SewerInsuranceAgentEmail: OptionalEmailString,
  address8SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address8SewerInsuranceCompanyName: z.string().optional(),
  address8SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8SewerInsuranceCompanyAddressCity: z.string().optional(),
  address8SewerInsuranceCompanyAddressState: z.string().optional(),
  address8SewerInsuranceCompanyAddressZip: z.string().optional(),
  address8SewerInsurancePolicyNumber: z.string().optional(),
  address8SewerInsurancePolicyStart: DateString.optional(),
  address8SewerInsurancePolicyEnd: DateString.optional(),
  address8SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address8EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8EquipmentInsuranceAgentName: z.string().optional(),
  address8EquipmentInsuranceAgentEmail: OptionalEmailString,
  address8EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address8EquipmentInsuranceCompanyName: z.string().optional(),
  address8EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address8EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address8EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address8EquipmentInsurancePolicyNumber: z.string().optional(),
  address8EquipmentInsurancePolicyStart: DateString.optional(),
  address8EquipmentInsurancePolicyEnd: DateString.optional(),
  address8EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8TitleInsuranceIsEscrowed: Checkbox.optional(),
  address8TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8TitleInsuranceAgentName: z.string().optional(),
  address8TitleInsuranceAgentEmail: OptionalEmailString,
  address8TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address8TitleInsuranceCompanyName: z.string().optional(),
  address8TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8TitleInsuranceCompanyAddressCity: z.string().optional(),
  address8TitleInsuranceCompanyAddressState: z.string().optional(),
  address8TitleInsuranceCompanyAddressZip: z.string().optional(),
  address8TitleInsurancePolicyNumber: z.string().optional(),
  address8TitleInsurancePolicyStart: DateString.optional(),
  address8TitleInsurancePolicyEnd: DateString.optional(),
  address8TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address8OtherInsuranceIsEscrowed: Checkbox.optional(),
  address8OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address8OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address8OtherInsuranceAgentName: z.string().optional(),
  address8OtherInsuranceAgentEmail: OptionalEmailString,
  address8OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address8OtherInsuranceCompanyName: z.string().optional(),
  address8OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address8OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address8OtherInsuranceCompanyAddressCity: z.string().optional(),
  address8OtherInsuranceCompanyAddressState: z.string().optional(),
  address8OtherInsuranceCompanyAddressZip: z.string().optional(),
  address8OtherInsurancePolicyNumber: z.string().optional(),
  address8OtherInsurancePolicyStart: DateString.optional(),
  address8OtherInsurancePolicyEnd: DateString.optional(),
  address8OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address9HazardInsuranceIsEscrowed: Checkbox.optional(),
  address9HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9HazardInsuranceAgentName: z.string().optional(),
  address9HazardInsuranceAgentEmail: OptionalEmailString,
  address9HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address9HazardInsuranceCompanyName: z.string().optional(),
  address9HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9HazardInsuranceCompanyAddressCity: z.string().optional(),
  address9HazardInsuranceCompanyAddressState: z.string().optional(),
  address9HazardInsuranceCompanyAddressZip: z.string().optional(),
  address9HazardInsurancePolicyNumber: z.string().optional(),
  address9HazardInsurancePolicyStart: DateString.optional(),
  address9HazardInsurancePolicyEnd: DateString.optional(),
  address9HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address9HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9HomeownersInsuranceAgentName: z.string().optional(),
  address9HomeownersInsuranceAgentEmail: OptionalEmailString,
  address9HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address9HomeownersInsuranceCompanyName: z.string().optional(),
  address9HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address9HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address9HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address9HomeownersInsurancePolicyNumber: z.string().optional(),
  address9HomeownersInsurancePolicyStart: DateString.optional(),
  address9HomeownersInsurancePolicyEnd: DateString.optional(),
  address9HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9FloodInsuranceIsEscrowed: Checkbox.optional(),
  address9FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9FloodInsuranceAgentName: z.string().optional(),
  address9FloodInsuranceAgentEmail: OptionalEmailString,
  address9FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address9FloodInsuranceCompanyName: z.string().optional(),
  address9FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9FloodInsuranceCompanyAddressCity: z.string().optional(),
  address9FloodInsuranceCompanyAddressState: z.string().optional(),
  address9FloodInsuranceCompanyAddressZip: z.string().optional(),
  address9FloodInsurancePolicyNumber: z.string().optional(),
  address9FloodInsurancePolicyStart: DateString.optional(),
  address9FloodInsurancePolicyEnd: DateString.optional(),
  address9FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address9WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9WindstormInsuranceAgentName: z.string().optional(),
  address9WindstormInsuranceAgentEmail: OptionalEmailString,
  address9WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address9WindstormInsuranceCompanyName: z.string().optional(),
  address9WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address9WindstormInsuranceCompanyAddressState: z.string().optional(),
  address9WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address9WindstormInsurancePolicyNumber: z.string().optional(),
  address9WindstormInsurancePolicyStart: DateString.optional(),
  address9WindstormInsurancePolicyEnd: DateString.optional(),
  address9WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address9HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9HurricaneInsuranceAgentName: z.string().optional(),
  address9HurricaneInsuranceAgentEmail: OptionalEmailString,
  address9HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address9HurricaneInsuranceCompanyName: z.string().optional(),
  address9HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address9HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address9HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address9HurricaneInsurancePolicyNumber: z.string().optional(),
  address9HurricaneInsurancePolicyStart: DateString.optional(),
  address9HurricaneInsurancePolicyEnd: DateString.optional(),
  address9HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9FireInsuranceIsEscrowed: Checkbox.optional(),
  address9FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9FireInsuranceAgentName: z.string().optional(),
  address9FireInsuranceAgentEmail: OptionalEmailString,
  address9FireInsuranceAgentPhone: OptionalPhoneNumber,
  address9FireInsuranceCompanyName: z.string().optional(),
  address9FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9FireInsuranceCompanyAddressCity: z.string().optional(),
  address9FireInsuranceCompanyAddressState: z.string().optional(),
  address9FireInsuranceCompanyAddressZip: z.string().optional(),
  address9FireInsurancePolicyNumber: z.string().optional(),
  address9FireInsurancePolicyStart: DateString.optional(),
  address9FireInsurancePolicyEnd: DateString.optional(),
  address9FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address9LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9LiabilityInsuranceAgentName: z.string().optional(),
  address9LiabilityInsuranceAgentEmail: OptionalEmailString,
  address9LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address9LiabilityInsuranceCompanyName: z.string().optional(),
  address9LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address9LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address9LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address9LiabilityInsurancePolicyNumber: z.string().optional(),
  address9LiabilityInsurancePolicyStart: DateString.optional(),
  address9LiabilityInsurancePolicyEnd: DateString.optional(),
  address9LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9RentalInsuranceIsEscrowed: Checkbox.optional(),
  address9RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9RentalInsuranceAgentName: z.string().optional(),
  address9RentalInsuranceAgentEmail: OptionalEmailString,
  address9RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address9RentalInsuranceCompanyName: z.string().optional(),
  address9RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9RentalInsuranceCompanyAddressCity: z.string().optional(),
  address9RentalInsuranceCompanyAddressState: z.string().optional(),
  address9RentalInsuranceCompanyAddressZip: z.string().optional(),
  address9RentalInsurancePolicyNumber: z.string().optional(),
  address9RentalInsurancePolicyStart: DateString.optional(),
  address9RentalInsurancePolicyEnd: DateString.optional(),
  address9RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9CondoInsuranceIsEscrowed: Checkbox.optional(),
  address9CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9CondoInsuranceAgentName: z.string().optional(),
  address9CondoInsuranceAgentEmail: OptionalEmailString,
  address9CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address9CondoInsuranceCompanyName: z.string().optional(),
  address9CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9CondoInsuranceCompanyAddressCity: z.string().optional(),
  address9CondoInsuranceCompanyAddressState: z.string().optional(),
  address9CondoInsuranceCompanyAddressZip: z.string().optional(),
  address9CondoInsurancePolicyNumber: z.string().optional(),
  address9CondoInsurancePolicyStart: DateString.optional(),
  address9CondoInsurancePolicyEnd: DateString.optional(),
  address9CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address9EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9EarthquakeInsuranceAgentName: z.string().optional(),
  address9EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address9EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address9EarthquakeInsuranceCompanyName: z.string().optional(),
  address9EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address9EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address9EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address9EarthquakeInsurancePolicyNumber: z.string().optional(),
  address9EarthquakeInsurancePolicyStart: DateString.optional(),
  address9EarthquakeInsurancePolicyEnd: DateString.optional(),
  address9EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address9UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9UmbrellaInsuranceAgentName: z.string().optional(),
  address9UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address9UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address9UmbrellaInsuranceCompanyName: z.string().optional(),
  address9UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address9UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address9UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address9UmbrellaInsurancePolicyNumber: z.string().optional(),
  address9UmbrellaInsurancePolicyStart: DateString.optional(),
  address9UmbrellaInsurancePolicyEnd: DateString.optional(),
  address9UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address9SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9SinkholeInsuranceAgentName: z.string().optional(),
  address9SinkholeInsuranceAgentEmail: OptionalEmailString,
  address9SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address9SinkholeInsuranceCompanyName: z.string().optional(),
  address9SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address9SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address9SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address9SinkholeInsurancePolicyNumber: z.string().optional(),
  address9SinkholeInsurancePolicyStart: DateString.optional(),
  address9SinkholeInsurancePolicyEnd: DateString.optional(),
  address9SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address9WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9WildfireInsuranceAgentName: z.string().optional(),
  address9WildfireInsuranceAgentEmail: OptionalEmailString,
  address9WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address9WildfireInsuranceCompanyName: z.string().optional(),
  address9WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address9WildfireInsuranceCompanyAddressState: z.string().optional(),
  address9WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address9WildfireInsurancePolicyNumber: z.string().optional(),
  address9WildfireInsurancePolicyStart: DateString.optional(),
  address9WildfireInsurancePolicyEnd: DateString.optional(),
  address9WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9SewerInsuranceIsEscrowed: Checkbox.optional(),
  address9SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9SewerInsuranceAgentName: z.string().optional(),
  address9SewerInsuranceAgentEmail: OptionalEmailString,
  address9SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address9SewerInsuranceCompanyName: z.string().optional(),
  address9SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9SewerInsuranceCompanyAddressCity: z.string().optional(),
  address9SewerInsuranceCompanyAddressState: z.string().optional(),
  address9SewerInsuranceCompanyAddressZip: z.string().optional(),
  address9SewerInsurancePolicyNumber: z.string().optional(),
  address9SewerInsurancePolicyStart: DateString.optional(),
  address9SewerInsurancePolicyEnd: DateString.optional(),
  address9SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address9EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9EquipmentInsuranceAgentName: z.string().optional(),
  address9EquipmentInsuranceAgentEmail: OptionalEmailString,
  address9EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address9EquipmentInsuranceCompanyName: z.string().optional(),
  address9EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address9EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address9EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address9EquipmentInsurancePolicyNumber: z.string().optional(),
  address9EquipmentInsurancePolicyStart: DateString.optional(),
  address9EquipmentInsurancePolicyEnd: DateString.optional(),
  address9EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9TitleInsuranceIsEscrowed: Checkbox.optional(),
  address9TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9TitleInsuranceAgentName: z.string().optional(),
  address9TitleInsuranceAgentEmail: OptionalEmailString,
  address9TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address9TitleInsuranceCompanyName: z.string().optional(),
  address9TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9TitleInsuranceCompanyAddressCity: z.string().optional(),
  address9TitleInsuranceCompanyAddressState: z.string().optional(),
  address9TitleInsuranceCompanyAddressZip: z.string().optional(),
  address9TitleInsurancePolicyNumber: z.string().optional(),
  address9TitleInsurancePolicyStart: DateString.optional(),
  address9TitleInsurancePolicyEnd: DateString.optional(),
  address9TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address9OtherInsuranceIsEscrowed: Checkbox.optional(),
  address9OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address9OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address9OtherInsuranceAgentName: z.string().optional(),
  address9OtherInsuranceAgentEmail: OptionalEmailString,
  address9OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address9OtherInsuranceCompanyName: z.string().optional(),
  address9OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address9OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address9OtherInsuranceCompanyAddressCity: z.string().optional(),
  address9OtherInsuranceCompanyAddressState: z.string().optional(),
  address9OtherInsuranceCompanyAddressZip: z.string().optional(),
  address9OtherInsurancePolicyNumber: z.string().optional(),
  address9OtherInsurancePolicyStart: DateString.optional(),
  address9OtherInsurancePolicyEnd: DateString.optional(),
  address9OtherInsuranceForcedPlacedFlag: Checkbox.optional(),

  address10HazardInsuranceIsEscrowed: Checkbox.optional(),
  address10HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10HazardInsuranceAgentName: z.string().optional(),
  address10HazardInsuranceAgentEmail: OptionalEmailString,
  address10HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address10HazardInsuranceCompanyName: z.string().optional(),
  address10HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10HazardInsuranceCompanyAddressCity: z.string().optional(),
  address10HazardInsuranceCompanyAddressState: z.string().optional(),
  address10HazardInsuranceCompanyAddressZip: z.string().optional(),
  address10HazardInsurancePolicyNumber: z.string().optional(),
  address10HazardInsurancePolicyStart: DateString.optional(),
  address10HazardInsurancePolicyEnd: DateString.optional(),
  address10HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address10HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10HomeownersInsuranceAgentName: z.string().optional(),
  address10HomeownersInsuranceAgentEmail: OptionalEmailString,
  address10HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address10HomeownersInsuranceCompanyName: z.string().optional(),
  address10HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address10HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address10HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address10HomeownersInsurancePolicyNumber: z.string().optional(),
  address10HomeownersInsurancePolicyStart: DateString.optional(),
  address10HomeownersInsurancePolicyEnd: DateString.optional(),
  address10HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10FloodInsuranceIsEscrowed: Checkbox.optional(),
  address10FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10FloodInsuranceAgentName: z.string().optional(),
  address10FloodInsuranceAgentEmail: OptionalEmailString,
  address10FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address10FloodInsuranceCompanyName: z.string().optional(),
  address10FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10FloodInsuranceCompanyAddressCity: z.string().optional(),
  address10FloodInsuranceCompanyAddressState: z.string().optional(),
  address10FloodInsuranceCompanyAddressZip: z.string().optional(),
  address10FloodInsurancePolicyNumber: z.string().optional(),
  address10FloodInsurancePolicyStart: DateString.optional(),
  address10FloodInsurancePolicyEnd: DateString.optional(),
  address10FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address10WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10WindstormInsuranceAgentName: z.string().optional(),
  address10WindstormInsuranceAgentEmail: OptionalEmailString,
  address10WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address10WindstormInsuranceCompanyName: z.string().optional(),
  address10WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address10WindstormInsuranceCompanyAddressState: z.string().optional(),
  address10WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address10WindstormInsurancePolicyNumber: z.string().optional(),
  address10WindstormInsurancePolicyStart: DateString.optional(),
  address10WindstormInsurancePolicyEnd: DateString.optional(),
  address10WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address10HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10HurricaneInsuranceAgentName: z.string().optional(),
  address10HurricaneInsuranceAgentEmail: OptionalEmailString,
  address10HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address10HurricaneInsuranceCompanyName: z.string().optional(),
  address10HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address10HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address10HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address10HurricaneInsurancePolicyNumber: z.string().optional(),
  address10HurricaneInsurancePolicyStart: DateString.optional(),
  address10HurricaneInsurancePolicyEnd: DateString.optional(),
  address10HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10FireInsuranceIsEscrowed: Checkbox.optional(),
  address10FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10FireInsuranceAgentName: z.string().optional(),
  address10FireInsuranceAgentEmail: OptionalEmailString,
  address10FireInsuranceAgentPhone: OptionalPhoneNumber,
  address10FireInsuranceCompanyName: z.string().optional(),
  address10FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10FireInsuranceCompanyAddressCity: z.string().optional(),
  address10FireInsuranceCompanyAddressState: z.string().optional(),
  address10FireInsuranceCompanyAddressZip: z.string().optional(),
  address10FireInsurancePolicyNumber: z.string().optional(),
  address10FireInsurancePolicyStart: DateString.optional(),
  address10FireInsurancePolicyEnd: DateString.optional(),
  address10FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address10LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10LiabilityInsuranceAgentName: z.string().optional(),
  address10LiabilityInsuranceAgentEmail: OptionalEmailString,
  address10LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address10LiabilityInsuranceCompanyName: z.string().optional(),
  address10LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address10LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address10LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address10LiabilityInsurancePolicyNumber: z.string().optional(),
  address10LiabilityInsurancePolicyStart: DateString.optional(),
  address10LiabilityInsurancePolicyEnd: DateString.optional(),
  address10LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10RentalInsuranceIsEscrowed: Checkbox.optional(),
  address10RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10RentalInsuranceAgentName: z.string().optional(),
  address10RentalInsuranceAgentEmail: OptionalEmailString,
  address10RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address10RentalInsuranceCompanyName: z.string().optional(),
  address10RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10RentalInsuranceCompanyAddressCity: z.string().optional(),
  address10RentalInsuranceCompanyAddressState: z.string().optional(),
  address10RentalInsuranceCompanyAddressZip: z.string().optional(),
  address10RentalInsurancePolicyNumber: z.string().optional(),
  address10RentalInsurancePolicyStart: DateString.optional(),
  address10RentalInsurancePolicyEnd: DateString.optional(),
  address10RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10CondoInsuranceIsEscrowed: Checkbox.optional(),
  address10CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10CondoInsuranceAgentName: z.string().optional(),
  address10CondoInsuranceAgentEmail: OptionalEmailString,
  address10CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address10CondoInsuranceCompanyName: z.string().optional(),
  address10CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10CondoInsuranceCompanyAddressCity: z.string().optional(),
  address10CondoInsuranceCompanyAddressState: z.string().optional(),
  address10CondoInsuranceCompanyAddressZip: z.string().optional(),
  address10CondoInsurancePolicyNumber: z.string().optional(),
  address10CondoInsurancePolicyStart: DateString.optional(),
  address10CondoInsurancePolicyEnd: DateString.optional(),
  address10CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address10EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10EarthquakeInsuranceAgentName: z.string().optional(),
  address10EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address10EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address10EarthquakeInsuranceCompanyName: z.string().optional(),
  address10EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address10EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address10EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address10EarthquakeInsurancePolicyNumber: z.string().optional(),
  address10EarthquakeInsurancePolicyStart: DateString.optional(),
  address10EarthquakeInsurancePolicyEnd: DateString.optional(),
  address10EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address10UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10UmbrellaInsuranceAgentName: z.string().optional(),
  address10UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address10UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address10UmbrellaInsuranceCompanyName: z.string().optional(),
  address10UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address10UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address10UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address10UmbrellaInsurancePolicyNumber: z.string().optional(),
  address10UmbrellaInsurancePolicyStart: DateString.optional(),
  address10UmbrellaInsurancePolicyEnd: DateString.optional(),
  address10UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address10SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10SinkholeInsuranceAgentName: z.string().optional(),
  address10SinkholeInsuranceAgentEmail: OptionalEmailString,
  address10SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address10SinkholeInsuranceCompanyName: z.string().optional(),
  address10SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address10SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address10SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address10SinkholeInsurancePolicyNumber: z.string().optional(),
  address10SinkholeInsurancePolicyStart: DateString.optional(),
  address10SinkholeInsurancePolicyEnd: DateString.optional(),
  address10SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address10WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10WildfireInsuranceAgentName: z.string().optional(),
  address10WildfireInsuranceAgentEmail: OptionalEmailString,
  address10WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address10WildfireInsuranceCompanyName: z.string().optional(),
  address10WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address10WildfireInsuranceCompanyAddressState: z.string().optional(),
  address10WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address10WildfireInsurancePolicyNumber: z.string().optional(),
  address10WildfireInsurancePolicyStart: DateString.optional(),
  address10WildfireInsurancePolicyEnd: DateString.optional(),
  address10WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10SewerInsuranceIsEscrowed: Checkbox.optional(),
  address10SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10SewerInsuranceAgentName: z.string().optional(),
  address10SewerInsuranceAgentEmail: OptionalEmailString,
  address10SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address10SewerInsuranceCompanyName: z.string().optional(),
  address10SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10SewerInsuranceCompanyAddressCity: z.string().optional(),
  address10SewerInsuranceCompanyAddressState: z.string().optional(),
  address10SewerInsuranceCompanyAddressZip: z.string().optional(),
  address10SewerInsurancePolicyNumber: z.string().optional(),
  address10SewerInsurancePolicyStart: DateString.optional(),
  address10SewerInsurancePolicyEnd: DateString.optional(),
  address10SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address10EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10EquipmentInsuranceAgentName: z.string().optional(),
  address10EquipmentInsuranceAgentEmail: OptionalEmailString,
  address10EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address10EquipmentInsuranceCompanyName: z.string().optional(),
  address10EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address10EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address10EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address10EquipmentInsurancePolicyNumber: z.string().optional(),
  address10EquipmentInsurancePolicyStart: DateString.optional(),
  address10EquipmentInsurancePolicyEnd: DateString.optional(),
  address10EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10TitleInsuranceIsEscrowed: Checkbox.optional(),
  address10TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10TitleInsuranceAgentName: z.string().optional(),
  address10TitleInsuranceAgentEmail: OptionalEmailString,
  address10TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address10TitleInsuranceCompanyName: z.string().optional(),
  address10TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10TitleInsuranceCompanyAddressCity: z.string().optional(),
  address10TitleInsuranceCompanyAddressState: z.string().optional(),
  address10TitleInsuranceCompanyAddressZip: z.string().optional(),
  address10TitleInsurancePolicyNumber: z.string().optional(),
  address10TitleInsurancePolicyStart: DateString.optional(),
  address10TitleInsurancePolicyEnd: DateString.optional(),
  address10TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address10OtherInsuranceIsEscrowed: Checkbox.optional(),
  address10OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address10OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address10OtherInsuranceAgentName: z.string().optional(),
  address10OtherInsuranceAgentEmail: OptionalEmailString,
  address10OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address10OtherInsuranceCompanyName: z.string().optional(),
  address10OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address10OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address10OtherInsuranceCompanyAddressCity: z.string().optional(),
  address10OtherInsuranceCompanyAddressState: z.string().optional(),
  address10OtherInsuranceCompanyAddressZip: z.string().optional(),
  address10OtherInsurancePolicyNumber: z.string().optional(),
  address10OtherInsurancePolicyStart: DateString.optional(),
  address10OtherInsurancePolicyEnd: DateString.optional(),
  address10OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11HazardInsuranceIsEscrowed: Checkbox.optional(),
  address11HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11HazardInsuranceAgentName: z.string().optional(),
  address11HazardInsuranceAgentEmail: OptionalEmailString,
  address11HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address11HazardInsuranceCompanyName: z.string().optional(),
  address11HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11HazardInsuranceCompanyAddressCity: z.string().optional(),
  address11HazardInsuranceCompanyAddressState: z.string().optional(),
  address11HazardInsuranceCompanyAddressZip: z.string().optional(),
  address11HazardInsurancePolicyNumber: z.string().optional(),
  address11HazardInsurancePolicyStart: DateString.optional(),
  address11HazardInsurancePolicyEnd: DateString.optional(),
  address11HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address11HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11HomeownersInsuranceAgentName: z.string().optional(),
  address11HomeownersInsuranceAgentEmail: OptionalEmailString,
  address11HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address11HomeownersInsuranceCompanyName: z.string().optional(),
  address11HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address11HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address11HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address11HomeownersInsurancePolicyNumber: z.string().optional(),
  address11HomeownersInsurancePolicyStart: DateString.optional(),
  address11HomeownersInsurancePolicyEnd: DateString.optional(),
  address11HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11FloodInsuranceIsEscrowed: Checkbox.optional(),
  address11FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11FloodInsuranceAgentName: z.string().optional(),
  address11FloodInsuranceAgentEmail: OptionalEmailString,
  address11FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address11FloodInsuranceCompanyName: z.string().optional(),
  address11FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11FloodInsuranceCompanyAddressCity: z.string().optional(),
  address11FloodInsuranceCompanyAddressState: z.string().optional(),
  address11FloodInsuranceCompanyAddressZip: z.string().optional(),
  address11FloodInsurancePolicyNumber: z.string().optional(),
  address11FloodInsurancePolicyStart: DateString.optional(),
  address11FloodInsurancePolicyEnd: DateString.optional(),
  address11FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address11WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11WindstormInsuranceAgentName: z.string().optional(),
  address11WindstormInsuranceAgentEmail: OptionalEmailString,
  address11WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address11WindstormInsuranceCompanyName: z.string().optional(),
  address11WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address11WindstormInsuranceCompanyAddressState: z.string().optional(),
  address11WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address11WindstormInsurancePolicyNumber: z.string().optional(),
  address11WindstormInsurancePolicyStart: DateString.optional(),
  address11WindstormInsurancePolicyEnd: DateString.optional(),
  address11WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address11HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11HurricaneInsuranceAgentName: z.string().optional(),
  address11HurricaneInsuranceAgentEmail: OptionalEmailString,
  address11HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address11HurricaneInsuranceCompanyName: z.string().optional(),
  address11HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address11HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address11HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address11HurricaneInsurancePolicyNumber: z.string().optional(),
  address11HurricaneInsurancePolicyStart: DateString.optional(),
  address11HurricaneInsurancePolicyEnd: DateString.optional(),
  address11HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11FireInsuranceIsEscrowed: Checkbox.optional(),
  address11FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11FireInsuranceAgentName: z.string().optional(),
  address11FireInsuranceAgentEmail: OptionalEmailString,
  address11FireInsuranceAgentPhone: OptionalPhoneNumber,
  address11FireInsuranceCompanyName: z.string().optional(),
  address11FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11FireInsuranceCompanyAddressCity: z.string().optional(),
  address11FireInsuranceCompanyAddressState: z.string().optional(),
  address11FireInsuranceCompanyAddressZip: z.string().optional(),
  address11FireInsurancePolicyNumber: z.string().optional(),
  address11FireInsurancePolicyStart: DateString.optional(),
  address11FireInsurancePolicyEnd: DateString.optional(),
  address11FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address11LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11LiabilityInsuranceAgentName: z.string().optional(),
  address11LiabilityInsuranceAgentEmail: OptionalEmailString,
  address11LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address11LiabilityInsuranceCompanyName: z.string().optional(),
  address11LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address11LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address11LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address11LiabilityInsurancePolicyNumber: z.string().optional(),
  address11LiabilityInsurancePolicyStart: DateString.optional(),
  address11LiabilityInsurancePolicyEnd: DateString.optional(),
  address11LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11RentalInsuranceIsEscrowed: Checkbox.optional(),
  address11RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11RentalInsuranceAgentName: z.string().optional(),
  address11RentalInsuranceAgentEmail: OptionalEmailString,
  address11RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address11RentalInsuranceCompanyName: z.string().optional(),
  address11RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11RentalInsuranceCompanyAddressCity: z.string().optional(),
  address11RentalInsuranceCompanyAddressState: z.string().optional(),
  address11RentalInsuranceCompanyAddressZip: z.string().optional(),
  address11RentalInsurancePolicyNumber: z.string().optional(),
  address11RentalInsurancePolicyStart: DateString.optional(),
  address11RentalInsurancePolicyEnd: DateString.optional(),
  address11RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11CondoInsuranceIsEscrowed: Checkbox.optional(),
  address11CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11CondoInsuranceAgentName: z.string().optional(),
  address11CondoInsuranceAgentEmail: OptionalEmailString,
  address11CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address11CondoInsuranceCompanyName: z.string().optional(),
  address11CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11CondoInsuranceCompanyAddressCity: z.string().optional(),
  address11CondoInsuranceCompanyAddressState: z.string().optional(),
  address11CondoInsuranceCompanyAddressZip: z.string().optional(),
  address11CondoInsurancePolicyNumber: z.string().optional(),
  address11CondoInsurancePolicyStart: DateString.optional(),
  address11CondoInsurancePolicyEnd: DateString.optional(),
  address11CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address11EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11EarthquakeInsuranceAgentName: z.string().optional(),
  address11EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address11EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address11EarthquakeInsuranceCompanyName: z.string().optional(),
  address11EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address11EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address11EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address11EarthquakeInsurancePolicyNumber: z.string().optional(),
  address11EarthquakeInsurancePolicyStart: DateString.optional(),
  address11EarthquakeInsurancePolicyEnd: DateString.optional(),
  address11EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address11UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11UmbrellaInsuranceAgentName: z.string().optional(),
  address11UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address11UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address11UmbrellaInsuranceCompanyName: z.string().optional(),
  address11UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address11UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address11UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address11UmbrellaInsurancePolicyNumber: z.string().optional(),
  address11UmbrellaInsurancePolicyStart: DateString.optional(),
  address11UmbrellaInsurancePolicyEnd: DateString.optional(),
  address11UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address11SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11SinkholeInsuranceAgentName: z.string().optional(),
  address11SinkholeInsuranceAgentEmail: OptionalEmailString,
  address11SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address11SinkholeInsuranceCompanyName: z.string().optional(),
  address11SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address11SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address11SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address11SinkholeInsurancePolicyNumber: z.string().optional(),
  address11SinkholeInsurancePolicyStart: DateString.optional(),
  address11SinkholeInsurancePolicyEnd: DateString.optional(),
  address11SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address11WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11WildfireInsuranceAgentName: z.string().optional(),
  address11WildfireInsuranceAgentEmail: OptionalEmailString,
  address11WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address11WildfireInsuranceCompanyName: z.string().optional(),
  address11WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address11WildfireInsuranceCompanyAddressState: z.string().optional(),
  address11WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address11WildfireInsurancePolicyNumber: z.string().optional(),
  address11WildfireInsurancePolicyStart: DateString.optional(),
  address11WildfireInsurancePolicyEnd: DateString.optional(),
  address11WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11SewerInsuranceIsEscrowed: Checkbox.optional(),
  address11SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11SewerInsuranceAgentName: z.string().optional(),
  address11SewerInsuranceAgentEmail: OptionalEmailString,
  address11SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address11SewerInsuranceCompanyName: z.string().optional(),
  address11SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11SewerInsuranceCompanyAddressCity: z.string().optional(),
  address11SewerInsuranceCompanyAddressState: z.string().optional(),
  address11SewerInsuranceCompanyAddressZip: z.string().optional(),
  address11SewerInsurancePolicyNumber: z.string().optional(),
  address11SewerInsurancePolicyStart: DateString.optional(),
  address11SewerInsurancePolicyEnd: DateString.optional(),
  address11SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address11EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11EquipmentInsuranceAgentName: z.string().optional(),
  address11EquipmentInsuranceAgentEmail: OptionalEmailString,
  address11EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address11EquipmentInsuranceCompanyName: z.string().optional(),
  address11EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address11EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address11EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address11EquipmentInsurancePolicyNumber: z.string().optional(),
  address11EquipmentInsurancePolicyStart: DateString.optional(),
  address11EquipmentInsurancePolicyEnd: DateString.optional(),
  address11EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11TitleInsuranceIsEscrowed: Checkbox.optional(),
  address11TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11TitleInsuranceAgentName: z.string().optional(),
  address11TitleInsuranceAgentEmail: OptionalEmailString,
  address11TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address11TitleInsuranceCompanyName: z.string().optional(),
  address11TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11TitleInsuranceCompanyAddressCity: z.string().optional(),
  address11TitleInsuranceCompanyAddressState: z.string().optional(),
  address11TitleInsuranceCompanyAddressZip: z.string().optional(),
  address11TitleInsurancePolicyNumber: z.string().optional(),
  address11TitleInsurancePolicyStart: DateString.optional(),
  address11TitleInsurancePolicyEnd: DateString.optional(),
  address11TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address11OtherInsuranceIsEscrowed: Checkbox.optional(),
  address11OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address11OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address11OtherInsuranceAgentName: z.string().optional(),
  address11OtherInsuranceAgentEmail: OptionalEmailString,
  address11OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address11OtherInsuranceCompanyName: z.string().optional(),
  address11OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address11OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address11OtherInsuranceCompanyAddressCity: z.string().optional(),
  address11OtherInsuranceCompanyAddressState: z.string().optional(),
  address11OtherInsuranceCompanyAddressZip: z.string().optional(),
  address11OtherInsurancePolicyNumber: z.string().optional(),
  address11OtherInsurancePolicyStart: DateString.optional(),
  address11OtherInsurancePolicyEnd: DateString.optional(),
  address11OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12HazardInsuranceIsEscrowed: Checkbox.optional(),
  address12HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12HazardInsuranceAgentName: z.string().optional(),
  address12HazardInsuranceAgentEmail: OptionalEmailString,
  address12HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address12HazardInsuranceCompanyName: z.string().optional(),
  address12HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12HazardInsuranceCompanyAddressCity: z.string().optional(),
  address12HazardInsuranceCompanyAddressState: z.string().optional(),
  address12HazardInsuranceCompanyAddressZip: z.string().optional(),
  address12HazardInsurancePolicyNumber: z.string().optional(),
  address12HazardInsurancePolicyStart: DateString.optional(),
  address12HazardInsurancePolicyEnd: DateString.optional(),
  address12HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address12HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12HomeownersInsuranceAgentName: z.string().optional(),
  address12HomeownersInsuranceAgentEmail: OptionalEmailString,
  address12HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address12HomeownersInsuranceCompanyName: z.string().optional(),
  address12HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address12HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address12HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address12HomeownersInsurancePolicyNumber: z.string().optional(),
  address12HomeownersInsurancePolicyStart: DateString.optional(),
  address12HomeownersInsurancePolicyEnd: DateString.optional(),
  address12HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12FloodInsuranceIsEscrowed: Checkbox.optional(),
  address12FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12FloodInsuranceAgentName: z.string().optional(),
  address12FloodInsuranceAgentEmail: OptionalEmailString,
  address12FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address12FloodInsuranceCompanyName: z.string().optional(),
  address12FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12FloodInsuranceCompanyAddressCity: z.string().optional(),
  address12FloodInsuranceCompanyAddressState: z.string().optional(),
  address12FloodInsuranceCompanyAddressZip: z.string().optional(),
  address12FloodInsurancePolicyNumber: z.string().optional(),
  address12FloodInsurancePolicyStart: DateString.optional(),
  address12FloodInsurancePolicyEnd: DateString.optional(),
  address12FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address12WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12WindstormInsuranceAgentName: z.string().optional(),
  address12WindstormInsuranceAgentEmail: OptionalEmailString,
  address12WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address12WindstormInsuranceCompanyName: z.string().optional(),
  address12WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address12WindstormInsuranceCompanyAddressState: z.string().optional(),
  address12WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address12WindstormInsurancePolicyNumber: z.string().optional(),
  address12WindstormInsurancePolicyStart: DateString.optional(),
  address12WindstormInsurancePolicyEnd: DateString.optional(),
  address12WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address12HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12HurricaneInsuranceAgentName: z.string().optional(),
  address12HurricaneInsuranceAgentEmail: OptionalEmailString,
  address12HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address12HurricaneInsuranceCompanyName: z.string().optional(),
  address12HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address12HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address12HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address12HurricaneInsurancePolicyNumber: z.string().optional(),
  address12HurricaneInsurancePolicyStart: DateString.optional(),
  address12HurricaneInsurancePolicyEnd: DateString.optional(),
  address12HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12FireInsuranceIsEscrowed: Checkbox.optional(),
  address12FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12FireInsuranceAgentName: z.string().optional(),
  address12FireInsuranceAgentEmail: OptionalEmailString,
  address12FireInsuranceAgentPhone: OptionalPhoneNumber,
  address12FireInsuranceCompanyName: z.string().optional(),
  address12FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12FireInsuranceCompanyAddressCity: z.string().optional(),
  address12FireInsuranceCompanyAddressState: z.string().optional(),
  address12FireInsuranceCompanyAddressZip: z.string().optional(),
  address12FireInsurancePolicyNumber: z.string().optional(),
  address12FireInsurancePolicyStart: DateString.optional(),
  address12FireInsurancePolicyEnd: DateString.optional(),
  address12FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address12LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12LiabilityInsuranceAgentName: z.string().optional(),
  address12LiabilityInsuranceAgentEmail: OptionalEmailString,
  address12LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address12LiabilityInsuranceCompanyName: z.string().optional(),
  address12LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address12LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address12LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address12LiabilityInsurancePolicyNumber: z.string().optional(),
  address12LiabilityInsurancePolicyStart: DateString.optional(),
  address12LiabilityInsurancePolicyEnd: DateString.optional(),
  address12LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12RentalInsuranceIsEscrowed: Checkbox.optional(),
  address12RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12RentalInsuranceAgentName: z.string().optional(),
  address12RentalInsuranceAgentEmail: OptionalEmailString,
  address12RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address12RentalInsuranceCompanyName: z.string().optional(),
  address12RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12RentalInsuranceCompanyAddressCity: z.string().optional(),
  address12RentalInsuranceCompanyAddressState: z.string().optional(),
  address12RentalInsuranceCompanyAddressZip: z.string().optional(),
  address12RentalInsurancePolicyNumber: z.string().optional(),
  address12RentalInsurancePolicyStart: DateString.optional(),
  address12RentalInsurancePolicyEnd: DateString.optional(),
  address12RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12CondoInsuranceIsEscrowed: Checkbox.optional(),
  address12CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12CondoInsuranceAgentName: z.string().optional(),
  address12CondoInsuranceAgentEmail: OptionalEmailString,
  address12CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address12CondoInsuranceCompanyName: z.string().optional(),
  address12CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12CondoInsuranceCompanyAddressCity: z.string().optional(),
  address12CondoInsuranceCompanyAddressState: z.string().optional(),
  address12CondoInsuranceCompanyAddressZip: z.string().optional(),
  address12CondoInsurancePolicyNumber: z.string().optional(),
  address12CondoInsurancePolicyStart: DateString.optional(),
  address12CondoInsurancePolicyEnd: DateString.optional(),
  address12CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address12EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12EarthquakeInsuranceAgentName: z.string().optional(),
  address12EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address12EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address12EarthquakeInsuranceCompanyName: z.string().optional(),
  address12EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address12EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address12EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address12EarthquakeInsurancePolicyNumber: z.string().optional(),
  address12EarthquakeInsurancePolicyStart: DateString.optional(),
  address12EarthquakeInsurancePolicyEnd: DateString.optional(),
  address12EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address12UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12UmbrellaInsuranceAgentName: z.string().optional(),
  address12UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address12UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address12UmbrellaInsuranceCompanyName: z.string().optional(),
  address12UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address12UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address12UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address12UmbrellaInsurancePolicyNumber: z.string().optional(),
  address12UmbrellaInsurancePolicyStart: DateString.optional(),
  address12UmbrellaInsurancePolicyEnd: DateString.optional(),
  address12UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address12SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12SinkholeInsuranceAgentName: z.string().optional(),
  address12SinkholeInsuranceAgentEmail: OptionalEmailString,
  address12SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address12SinkholeInsuranceCompanyName: z.string().optional(),
  address12SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address12SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address12SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address12SinkholeInsurancePolicyNumber: z.string().optional(),
  address12SinkholeInsurancePolicyStart: DateString.optional(),
  address12SinkholeInsurancePolicyEnd: DateString.optional(),
  address12SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address12WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12WildfireInsuranceAgentName: z.string().optional(),
  address12WildfireInsuranceAgentEmail: OptionalEmailString,
  address12WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address12WildfireInsuranceCompanyName: z.string().optional(),
  address12WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address12WildfireInsuranceCompanyAddressState: z.string().optional(),
  address12WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address12WildfireInsurancePolicyNumber: z.string().optional(),
  address12WildfireInsurancePolicyStart: DateString.optional(),
  address12WildfireInsurancePolicyEnd: DateString.optional(),
  address12WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12SewerInsuranceIsEscrowed: Checkbox.optional(),
  address12SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12SewerInsuranceAgentName: z.string().optional(),
  address12SewerInsuranceAgentEmail: OptionalEmailString,
  address12SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address12SewerInsuranceCompanyName: z.string().optional(),
  address12SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12SewerInsuranceCompanyAddressCity: z.string().optional(),
  address12SewerInsuranceCompanyAddressState: z.string().optional(),
  address12SewerInsuranceCompanyAddressZip: z.string().optional(),
  address12SewerInsurancePolicyNumber: z.string().optional(),
  address12SewerInsurancePolicyStart: DateString.optional(),
  address12SewerInsurancePolicyEnd: DateString.optional(),
  address12SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address12EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12EquipmentInsuranceAgentName: z.string().optional(),
  address12EquipmentInsuranceAgentEmail: OptionalEmailString,
  address12EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address12EquipmentInsuranceCompanyName: z.string().optional(),
  address12EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address12EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address12EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address12EquipmentInsurancePolicyNumber: z.string().optional(),
  address12EquipmentInsurancePolicyStart: DateString.optional(),
  address12EquipmentInsurancePolicyEnd: DateString.optional(),
  address12EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12TitleInsuranceIsEscrowed: Checkbox.optional(),
  address12TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12TitleInsuranceAgentName: z.string().optional(),
  address12TitleInsuranceAgentEmail: OptionalEmailString,
  address12TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address12TitleInsuranceCompanyName: z.string().optional(),
  address12TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12TitleInsuranceCompanyAddressCity: z.string().optional(),
  address12TitleInsuranceCompanyAddressState: z.string().optional(),
  address12TitleInsuranceCompanyAddressZip: z.string().optional(),
  address12TitleInsurancePolicyNumber: z.string().optional(),
  address12TitleInsurancePolicyStart: DateString.optional(),
  address12TitleInsurancePolicyEnd: DateString.optional(),
  address12TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address12OtherInsuranceIsEscrowed: Checkbox.optional(),
  address12OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address12OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address12OtherInsuranceAgentName: z.string().optional(),
  address12OtherInsuranceAgentEmail: OptionalEmailString,
  address12OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address12OtherInsuranceCompanyName: z.string().optional(),
  address12OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address12OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address12OtherInsuranceCompanyAddressCity: z.string().optional(),
  address12OtherInsuranceCompanyAddressState: z.string().optional(),
  address12OtherInsuranceCompanyAddressZip: z.string().optional(),
  address12OtherInsurancePolicyNumber: z.string().optional(),
  address12OtherInsurancePolicyStart: DateString.optional(),
  address12OtherInsurancePolicyEnd: DateString.optional(),
  address12OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13HazardInsuranceIsEscrowed: Checkbox.optional(),
  address13HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13HazardInsuranceAgentName: z.string().optional(),
  address13HazardInsuranceAgentEmail: OptionalEmailString,
  address13HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address13HazardInsuranceCompanyName: z.string().optional(),
  address13HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13HazardInsuranceCompanyAddressCity: z.string().optional(),
  address13HazardInsuranceCompanyAddressState: z.string().optional(),
  address13HazardInsuranceCompanyAddressZip: z.string().optional(),
  address13HazardInsurancePolicyNumber: z.string().optional(),
  address13HazardInsurancePolicyStart: DateString.optional(),
  address13HazardInsurancePolicyEnd: DateString.optional(),
  address13HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address13HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13HomeownersInsuranceAgentName: z.string().optional(),
  address13HomeownersInsuranceAgentEmail: OptionalEmailString,
  address13HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address13HomeownersInsuranceCompanyName: z.string().optional(),
  address13HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address13HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address13HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address13HomeownersInsurancePolicyNumber: z.string().optional(),
  address13HomeownersInsurancePolicyStart: DateString.optional(),
  address13HomeownersInsurancePolicyEnd: DateString.optional(),
  address13HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13FloodInsuranceIsEscrowed: Checkbox.optional(),
  address13FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13FloodInsuranceAgentName: z.string().optional(),
  address13FloodInsuranceAgentEmail: OptionalEmailString,
  address13FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address13FloodInsuranceCompanyName: z.string().optional(),
  address13FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13FloodInsuranceCompanyAddressCity: z.string().optional(),
  address13FloodInsuranceCompanyAddressState: z.string().optional(),
  address13FloodInsuranceCompanyAddressZip: z.string().optional(),
  address13FloodInsurancePolicyNumber: z.string().optional(),
  address13FloodInsurancePolicyStart: DateString.optional(),
  address13FloodInsurancePolicyEnd: DateString.optional(),
  address13FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address13WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13WindstormInsuranceAgentName: z.string().optional(),
  address13WindstormInsuranceAgentEmail: OptionalEmailString,
  address13WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address13WindstormInsuranceCompanyName: z.string().optional(),
  address13WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address13WindstormInsuranceCompanyAddressState: z.string().optional(),
  address13WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address13WindstormInsurancePolicyNumber: z.string().optional(),
  address13WindstormInsurancePolicyStart: DateString.optional(),
  address13WindstormInsurancePolicyEnd: DateString.optional(),
  address13WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address13HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13HurricaneInsuranceAgentName: z.string().optional(),
  address13HurricaneInsuranceAgentEmail: OptionalEmailString,
  address13HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address13HurricaneInsuranceCompanyName: z.string().optional(),
  address13HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address13HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address13HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address13HurricaneInsurancePolicyNumber: z.string().optional(),
  address13HurricaneInsurancePolicyStart: DateString.optional(),
  address13HurricaneInsurancePolicyEnd: DateString.optional(),
  address13HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13FireInsuranceIsEscrowed: Checkbox.optional(),
  address13FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13FireInsuranceAgentName: z.string().optional(),
  address13FireInsuranceAgentEmail: OptionalEmailString,
  address13FireInsuranceAgentPhone: OptionalPhoneNumber,
  address13FireInsuranceCompanyName: z.string().optional(),
  address13FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13FireInsuranceCompanyAddressCity: z.string().optional(),
  address13FireInsuranceCompanyAddressState: z.string().optional(),
  address13FireInsuranceCompanyAddressZip: z.string().optional(),
  address13FireInsurancePolicyNumber: z.string().optional(),
  address13FireInsurancePolicyStart: DateString.optional(),
  address13FireInsurancePolicyEnd: DateString.optional(),
  address13FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address13LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13LiabilityInsuranceAgentName: z.string().optional(),
  address13LiabilityInsuranceAgentEmail: OptionalEmailString,
  address13LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address13LiabilityInsuranceCompanyName: z.string().optional(),
  address13LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address13LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address13LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address13LiabilityInsurancePolicyNumber: z.string().optional(),
  address13LiabilityInsurancePolicyStart: DateString.optional(),
  address13LiabilityInsurancePolicyEnd: DateString.optional(),
  address13LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13RentalInsuranceIsEscrowed: Checkbox.optional(),
  address13RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13RentalInsuranceAgentName: z.string().optional(),
  address13RentalInsuranceAgentEmail: OptionalEmailString,
  address13RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address13RentalInsuranceCompanyName: z.string().optional(),
  address13RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13RentalInsuranceCompanyAddressCity: z.string().optional(),
  address13RentalInsuranceCompanyAddressState: z.string().optional(),
  address13RentalInsuranceCompanyAddressZip: z.string().optional(),
  address13RentalInsurancePolicyNumber: z.string().optional(),
  address13RentalInsurancePolicyStart: DateString.optional(),
  address13RentalInsurancePolicyEnd: DateString.optional(),
  address13RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13CondoInsuranceIsEscrowed: Checkbox.optional(),
  address13CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13CondoInsuranceAgentName: z.string().optional(),
  address13CondoInsuranceAgentEmail: OptionalEmailString,
  address13CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address13CondoInsuranceCompanyName: z.string().optional(),
  address13CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13CondoInsuranceCompanyAddressCity: z.string().optional(),
  address13CondoInsuranceCompanyAddressState: z.string().optional(),
  address13CondoInsuranceCompanyAddressZip: z.string().optional(),
  address13CondoInsurancePolicyNumber: z.string().optional(),
  address13CondoInsurancePolicyStart: DateString.optional(),
  address13CondoInsurancePolicyEnd: DateString.optional(),
  address13CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address13EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13EarthquakeInsuranceAgentName: z.string().optional(),
  address13EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address13EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address13EarthquakeInsuranceCompanyName: z.string().optional(),
  address13EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address13EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address13EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address13EarthquakeInsurancePolicyNumber: z.string().optional(),
  address13EarthquakeInsurancePolicyStart: DateString.optional(),
  address13EarthquakeInsurancePolicyEnd: DateString.optional(),
  address13EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address13UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13UmbrellaInsuranceAgentName: z.string().optional(),
  address13UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address13UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address13UmbrellaInsuranceCompanyName: z.string().optional(),
  address13UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address13UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address13UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address13UmbrellaInsurancePolicyNumber: z.string().optional(),
  address13UmbrellaInsurancePolicyStart: DateString.optional(),
  address13UmbrellaInsurancePolicyEnd: DateString.optional(),
  address13UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address13SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13SinkholeInsuranceAgentName: z.string().optional(),
  address13SinkholeInsuranceAgentEmail: OptionalEmailString,
  address13SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address13SinkholeInsuranceCompanyName: z.string().optional(),
  address13SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address13SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address13SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address13SinkholeInsurancePolicyNumber: z.string().optional(),
  address13SinkholeInsurancePolicyStart: DateString.optional(),
  address13SinkholeInsurancePolicyEnd: DateString.optional(),
  address13SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address13WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13WildfireInsuranceAgentName: z.string().optional(),
  address13WildfireInsuranceAgentEmail: OptionalEmailString,
  address13WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address13WildfireInsuranceCompanyName: z.string().optional(),
  address13WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address13WildfireInsuranceCompanyAddressState: z.string().optional(),
  address13WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address13WildfireInsurancePolicyNumber: z.string().optional(),
  address13WildfireInsurancePolicyStart: DateString.optional(),
  address13WildfireInsurancePolicyEnd: DateString.optional(),
  address13WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13SewerInsuranceIsEscrowed: Checkbox.optional(),
  address13SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13SewerInsuranceAgentName: z.string().optional(),
  address13SewerInsuranceAgentEmail: OptionalEmailString,
  address13SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address13SewerInsuranceCompanyName: z.string().optional(),
  address13SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13SewerInsuranceCompanyAddressCity: z.string().optional(),
  address13SewerInsuranceCompanyAddressState: z.string().optional(),
  address13SewerInsuranceCompanyAddressZip: z.string().optional(),
  address13SewerInsurancePolicyNumber: z.string().optional(),
  address13SewerInsurancePolicyStart: DateString.optional(),
  address13SewerInsurancePolicyEnd: DateString.optional(),
  address13SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address13EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13EquipmentInsuranceAgentName: z.string().optional(),
  address13EquipmentInsuranceAgentEmail: OptionalEmailString,
  address13EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address13EquipmentInsuranceCompanyName: z.string().optional(),
  address13EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address13EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address13EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address13EquipmentInsurancePolicyNumber: z.string().optional(),
  address13EquipmentInsurancePolicyStart: DateString.optional(),
  address13EquipmentInsurancePolicyEnd: DateString.optional(),
  address13EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13TitleInsuranceIsEscrowed: Checkbox.optional(),
  address13TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13TitleInsuranceAgentName: z.string().optional(),
  address13TitleInsuranceAgentEmail: OptionalEmailString,
  address13TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address13TitleInsuranceCompanyName: z.string().optional(),
  address13TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13TitleInsuranceCompanyAddressCity: z.string().optional(),
  address13TitleInsuranceCompanyAddressState: z.string().optional(),
  address13TitleInsuranceCompanyAddressZip: z.string().optional(),
  address13TitleInsurancePolicyNumber: z.string().optional(),
  address13TitleInsurancePolicyStart: DateString.optional(),
  address13TitleInsurancePolicyEnd: DateString.optional(),
  address13TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address13OtherInsuranceIsEscrowed: Checkbox.optional(),
  address13OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address13OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address13OtherInsuranceAgentName: z.string().optional(),
  address13OtherInsuranceAgentEmail: OptionalEmailString,
  address13OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address13OtherInsuranceCompanyName: z.string().optional(),
  address13OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address13OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address13OtherInsuranceCompanyAddressCity: z.string().optional(),
  address13OtherInsuranceCompanyAddressState: z.string().optional(),
  address13OtherInsuranceCompanyAddressZip: z.string().optional(),
  address13OtherInsurancePolicyNumber: z.string().optional(),
  address13OtherInsurancePolicyStart: DateString.optional(),
  address13OtherInsurancePolicyEnd: DateString.optional(),
  address13OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14HazardInsuranceIsEscrowed: Checkbox.optional(),
  address14HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14HazardInsuranceAgentName: z.string().optional(),
  address14HazardInsuranceAgentEmail: OptionalEmailString,
  address14HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address14HazardInsuranceCompanyName: z.string().optional(),
  address14HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14HazardInsuranceCompanyAddressCity: z.string().optional(),
  address14HazardInsuranceCompanyAddressState: z.string().optional(),
  address14HazardInsuranceCompanyAddressZip: z.string().optional(),
  address14HazardInsurancePolicyNumber: z.string().optional(),
  address14HazardInsurancePolicyStart: DateString.optional(),
  address14HazardInsurancePolicyEnd: DateString.optional(),
  address14HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address14HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14HomeownersInsuranceAgentName: z.string().optional(),
  address14HomeownersInsuranceAgentEmail: OptionalEmailString,
  address14HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address14HomeownersInsuranceCompanyName: z.string().optional(),
  address14HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address14HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address14HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address14HomeownersInsurancePolicyNumber: z.string().optional(),
  address14HomeownersInsurancePolicyStart: DateString.optional(),
  address14HomeownersInsurancePolicyEnd: DateString.optional(),
  address14HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14FloodInsuranceIsEscrowed: Checkbox.optional(),
  address14FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14FloodInsuranceAgentName: z.string().optional(),
  address14FloodInsuranceAgentEmail: OptionalEmailString,
  address14FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address14FloodInsuranceCompanyName: z.string().optional(),
  address14FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14FloodInsuranceCompanyAddressCity: z.string().optional(),
  address14FloodInsuranceCompanyAddressState: z.string().optional(),
  address14FloodInsuranceCompanyAddressZip: z.string().optional(),
  address14FloodInsurancePolicyNumber: z.string().optional(),
  address14FloodInsurancePolicyStart: DateString.optional(),
  address14FloodInsurancePolicyEnd: DateString.optional(),
  address14FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address14WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14WindstormInsuranceAgentName: z.string().optional(),
  address14WindstormInsuranceAgentEmail: OptionalEmailString,
  address14WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address14WindstormInsuranceCompanyName: z.string().optional(),
  address14WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address14WindstormInsuranceCompanyAddressState: z.string().optional(),
  address14WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address14WindstormInsurancePolicyNumber: z.string().optional(),
  address14WindstormInsurancePolicyStart: DateString.optional(),
  address14WindstormInsurancePolicyEnd: DateString.optional(),
  address14WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address14HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14HurricaneInsuranceAgentName: z.string().optional(),
  address14HurricaneInsuranceAgentEmail: OptionalEmailString,
  address14HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address14HurricaneInsuranceCompanyName: z.string().optional(),
  address14HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address14HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address14HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address14HurricaneInsurancePolicyNumber: z.string().optional(),
  address14HurricaneInsurancePolicyStart: DateString.optional(),
  address14HurricaneInsurancePolicyEnd: DateString.optional(),
  address14HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14FireInsuranceIsEscrowed: Checkbox.optional(),
  address14FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14FireInsuranceAgentName: z.string().optional(),
  address14FireInsuranceAgentEmail: OptionalEmailString,
  address14FireInsuranceAgentPhone: OptionalPhoneNumber,
  address14FireInsuranceCompanyName: z.string().optional(),
  address14FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14FireInsuranceCompanyAddressCity: z.string().optional(),
  address14FireInsuranceCompanyAddressState: z.string().optional(),
  address14FireInsuranceCompanyAddressZip: z.string().optional(),
  address14FireInsurancePolicyNumber: z.string().optional(),
  address14FireInsurancePolicyStart: DateString.optional(),
  address14FireInsurancePolicyEnd: DateString.optional(),
  address14FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address14LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14LiabilityInsuranceAgentName: z.string().optional(),
  address14LiabilityInsuranceAgentEmail: OptionalEmailString,
  address14LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address14LiabilityInsuranceCompanyName: z.string().optional(),
  address14LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address14LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address14LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address14LiabilityInsurancePolicyNumber: z.string().optional(),
  address14LiabilityInsurancePolicyStart: DateString.optional(),
  address14LiabilityInsurancePolicyEnd: DateString.optional(),
  address14LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14RentalInsuranceIsEscrowed: Checkbox.optional(),
  address14RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14RentalInsuranceAgentName: z.string().optional(),
  address14RentalInsuranceAgentEmail: OptionalEmailString,
  address14RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address14RentalInsuranceCompanyName: z.string().optional(),
  address14RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14RentalInsuranceCompanyAddressCity: z.string().optional(),
  address14RentalInsuranceCompanyAddressState: z.string().optional(),
  address14RentalInsuranceCompanyAddressZip: z.string().optional(),
  address14RentalInsurancePolicyNumber: z.string().optional(),
  address14RentalInsurancePolicyStart: DateString.optional(),
  address14RentalInsurancePolicyEnd: DateString.optional(),
  address14RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14CondoInsuranceIsEscrowed: Checkbox.optional(),
  address14CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14CondoInsuranceAgentName: z.string().optional(),
  address14CondoInsuranceAgentEmail: OptionalEmailString,
  address14CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address14CondoInsuranceCompanyName: z.string().optional(),
  address14CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14CondoInsuranceCompanyAddressCity: z.string().optional(),
  address14CondoInsuranceCompanyAddressState: z.string().optional(),
  address14CondoInsuranceCompanyAddressZip: z.string().optional(),
  address14CondoInsurancePolicyNumber: z.string().optional(),
  address14CondoInsurancePolicyStart: DateString.optional(),
  address14CondoInsurancePolicyEnd: DateString.optional(),
  address14CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address14EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14EarthquakeInsuranceAgentName: z.string().optional(),
  address14EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address14EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address14EarthquakeInsuranceCompanyName: z.string().optional(),
  address14EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address14EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address14EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address14EarthquakeInsurancePolicyNumber: z.string().optional(),
  address14EarthquakeInsurancePolicyStart: DateString.optional(),
  address14EarthquakeInsurancePolicyEnd: DateString.optional(),
  address14EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address14UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14UmbrellaInsuranceAgentName: z.string().optional(),
  address14UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address14UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address14UmbrellaInsuranceCompanyName: z.string().optional(),
  address14UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address14UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address14UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address14UmbrellaInsurancePolicyNumber: z.string().optional(),
  address14UmbrellaInsurancePolicyStart: DateString.optional(),
  address14UmbrellaInsurancePolicyEnd: DateString.optional(),
  address14UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address14SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14SinkholeInsuranceAgentName: z.string().optional(),
  address14SinkholeInsuranceAgentEmail: OptionalEmailString,
  address14SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address14SinkholeInsuranceCompanyName: z.string().optional(),
  address14SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address14SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address14SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address14SinkholeInsurancePolicyNumber: z.string().optional(),
  address14SinkholeInsurancePolicyStart: DateString.optional(),
  address14SinkholeInsurancePolicyEnd: DateString.optional(),
  address14SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address14WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14WildfireInsuranceAgentName: z.string().optional(),
  address14WildfireInsuranceAgentEmail: OptionalEmailString,
  address14WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address14WildfireInsuranceCompanyName: z.string().optional(),
  address14WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address14WildfireInsuranceCompanyAddressState: z.string().optional(),
  address14WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address14WildfireInsurancePolicyNumber: z.string().optional(),
  address14WildfireInsurancePolicyStart: DateString.optional(),
  address14WildfireInsurancePolicyEnd: DateString.optional(),
  address14WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14SewerInsuranceIsEscrowed: Checkbox.optional(),
  address14SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14SewerInsuranceAgentName: z.string().optional(),
  address14SewerInsuranceAgentEmail: OptionalEmailString,
  address14SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address14SewerInsuranceCompanyName: z.string().optional(),
  address14SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14SewerInsuranceCompanyAddressCity: z.string().optional(),
  address14SewerInsuranceCompanyAddressState: z.string().optional(),
  address14SewerInsuranceCompanyAddressZip: z.string().optional(),
  address14SewerInsurancePolicyNumber: z.string().optional(),
  address14SewerInsurancePolicyStart: DateString.optional(),
  address14SewerInsurancePolicyEnd: DateString.optional(),
  address14SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address14EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14EquipmentInsuranceAgentName: z.string().optional(),
  address14EquipmentInsuranceAgentEmail: OptionalEmailString,
  address14EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address14EquipmentInsuranceCompanyName: z.string().optional(),
  address14EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address14EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address14EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address14EquipmentInsurancePolicyNumber: z.string().optional(),
  address14EquipmentInsurancePolicyStart: DateString.optional(),
  address14EquipmentInsurancePolicyEnd: DateString.optional(),
  address14EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14TitleInsuranceIsEscrowed: Checkbox.optional(),
  address14TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14TitleInsuranceAgentName: z.string().optional(),
  address14TitleInsuranceAgentEmail: OptionalEmailString,
  address14TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address14TitleInsuranceCompanyName: z.string().optional(),
  address14TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14TitleInsuranceCompanyAddressCity: z.string().optional(),
  address14TitleInsuranceCompanyAddressState: z.string().optional(),
  address14TitleInsuranceCompanyAddressZip: z.string().optional(),
  address14TitleInsurancePolicyNumber: z.string().optional(),
  address14TitleInsurancePolicyStart: DateString.optional(),
  address14TitleInsurancePolicyEnd: DateString.optional(),
  address14TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address14OtherInsuranceIsEscrowed: Checkbox.optional(),
  address14OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address14OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address14OtherInsuranceAgentName: z.string().optional(),
  address14OtherInsuranceAgentEmail: OptionalEmailString,
  address14OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address14OtherInsuranceCompanyName: z.string().optional(),
  address14OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address14OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address14OtherInsuranceCompanyAddressCity: z.string().optional(),
  address14OtherInsuranceCompanyAddressState: z.string().optional(),
  address14OtherInsuranceCompanyAddressZip: z.string().optional(),
  address14OtherInsurancePolicyNumber: z.string().optional(),
  address14OtherInsurancePolicyStart: DateString.optional(),
  address14OtherInsurancePolicyEnd: DateString.optional(),
  address14OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15HazardInsuranceIsEscrowed: Checkbox.optional(),
  address15HazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15HazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15HazardInsuranceAgentName: z.string().optional(),
  address15HazardInsuranceAgentEmail: OptionalEmailString,
  address15HazardInsuranceAgentPhone: OptionalPhoneNumber,
  address15HazardInsuranceCompanyName: z.string().optional(),
  address15HazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15HazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15HazardInsuranceCompanyAddressCity: z.string().optional(),
  address15HazardInsuranceCompanyAddressState: z.string().optional(),
  address15HazardInsuranceCompanyAddressZip: z.string().optional(),
  address15HazardInsurancePolicyNumber: z.string().optional(),
  address15HazardInsurancePolicyStart: DateString.optional(),
  address15HazardInsurancePolicyEnd: DateString.optional(),
  address15HazardInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15HomeownersInsuranceIsEscrowed: Checkbox.optional(),
  address15HomeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15HomeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15HomeownersInsuranceAgentName: z.string().optional(),
  address15HomeownersInsuranceAgentEmail: OptionalEmailString,
  address15HomeownersInsuranceAgentPhone: OptionalPhoneNumber,
  address15HomeownersInsuranceCompanyName: z.string().optional(),
  address15HomeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15HomeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15HomeownersInsuranceCompanyAddressCity: z.string().optional(),
  address15HomeownersInsuranceCompanyAddressState: z.string().optional(),
  address15HomeownersInsuranceCompanyAddressZip: z.string().optional(),
  address15HomeownersInsurancePolicyNumber: z.string().optional(),
  address15HomeownersInsurancePolicyStart: DateString.optional(),
  address15HomeownersInsurancePolicyEnd: DateString.optional(),
  address15HomeownersInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15FloodInsuranceIsEscrowed: Checkbox.optional(),
  address15FloodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15FloodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15FloodInsuranceAgentName: z.string().optional(),
  address15FloodInsuranceAgentEmail: OptionalEmailString,
  address15FloodInsuranceAgentPhone: OptionalPhoneNumber,
  address15FloodInsuranceCompanyName: z.string().optional(),
  address15FloodInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15FloodInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15FloodInsuranceCompanyAddressCity: z.string().optional(),
  address15FloodInsuranceCompanyAddressState: z.string().optional(),
  address15FloodInsuranceCompanyAddressZip: z.string().optional(),
  address15FloodInsurancePolicyNumber: z.string().optional(),
  address15FloodInsurancePolicyStart: DateString.optional(),
  address15FloodInsurancePolicyEnd: DateString.optional(),
  address15FloodInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15WindstormInsuranceIsEscrowed: Checkbox.optional(),
  address15WindstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15WindstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15WindstormInsuranceAgentName: z.string().optional(),
  address15WindstormInsuranceAgentEmail: OptionalEmailString,
  address15WindstormInsuranceAgentPhone: OptionalPhoneNumber,
  address15WindstormInsuranceCompanyName: z.string().optional(),
  address15WindstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15WindstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15WindstormInsuranceCompanyAddressCity: z.string().optional(),
  address15WindstormInsuranceCompanyAddressState: z.string().optional(),
  address15WindstormInsuranceCompanyAddressZip: z.string().optional(),
  address15WindstormInsurancePolicyNumber: z.string().optional(),
  address15WindstormInsurancePolicyStart: DateString.optional(),
  address15WindstormInsurancePolicyEnd: DateString.optional(),
  address15WindstormInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15HurricaneInsuranceIsEscrowed: Checkbox.optional(),
  address15HurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15HurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15HurricaneInsuranceAgentName: z.string().optional(),
  address15HurricaneInsuranceAgentEmail: OptionalEmailString,
  address15HurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  address15HurricaneInsuranceCompanyName: z.string().optional(),
  address15HurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15HurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15HurricaneInsuranceCompanyAddressCity: z.string().optional(),
  address15HurricaneInsuranceCompanyAddressState: z.string().optional(),
  address15HurricaneInsuranceCompanyAddressZip: z.string().optional(),
  address15HurricaneInsurancePolicyNumber: z.string().optional(),
  address15HurricaneInsurancePolicyStart: DateString.optional(),
  address15HurricaneInsurancePolicyEnd: DateString.optional(),
  address15HurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15FireInsuranceIsEscrowed: Checkbox.optional(),
  address15FireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15FireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15FireInsuranceAgentName: z.string().optional(),
  address15FireInsuranceAgentEmail: OptionalEmailString,
  address15FireInsuranceAgentPhone: OptionalPhoneNumber,
  address15FireInsuranceCompanyName: z.string().optional(),
  address15FireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15FireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15FireInsuranceCompanyAddressCity: z.string().optional(),
  address15FireInsuranceCompanyAddressState: z.string().optional(),
  address15FireInsuranceCompanyAddressZip: z.string().optional(),
  address15FireInsurancePolicyNumber: z.string().optional(),
  address15FireInsurancePolicyStart: DateString.optional(),
  address15FireInsurancePolicyEnd: DateString.optional(),
  address15FireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15LiabilityInsuranceIsEscrowed: Checkbox.optional(),
  address15LiabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15LiabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15LiabilityInsuranceAgentName: z.string().optional(),
  address15LiabilityInsuranceAgentEmail: OptionalEmailString,
  address15LiabilityInsuranceAgentPhone: OptionalPhoneNumber,
  address15LiabilityInsuranceCompanyName: z.string().optional(),
  address15LiabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15LiabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15LiabilityInsuranceCompanyAddressCity: z.string().optional(),
  address15LiabilityInsuranceCompanyAddressState: z.string().optional(),
  address15LiabilityInsuranceCompanyAddressZip: z.string().optional(),
  address15LiabilityInsurancePolicyNumber: z.string().optional(),
  address15LiabilityInsurancePolicyStart: DateString.optional(),
  address15LiabilityInsurancePolicyEnd: DateString.optional(),
  address15LiabilityInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15RentalInsuranceIsEscrowed: Checkbox.optional(),
  address15RentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15RentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15RentalInsuranceAgentName: z.string().optional(),
  address15RentalInsuranceAgentEmail: OptionalEmailString,
  address15RentalInsuranceAgentPhone: OptionalPhoneNumber,
  address15RentalInsuranceCompanyName: z.string().optional(),
  address15RentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15RentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15RentalInsuranceCompanyAddressCity: z.string().optional(),
  address15RentalInsuranceCompanyAddressState: z.string().optional(),
  address15RentalInsuranceCompanyAddressZip: z.string().optional(),
  address15RentalInsurancePolicyNumber: z.string().optional(),
  address15RentalInsurancePolicyStart: DateString.optional(),
  address15RentalInsurancePolicyEnd: DateString.optional(),
  address15RentalInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15CondoInsuranceIsEscrowed: Checkbox.optional(),
  address15CondoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15CondoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15CondoInsuranceAgentName: z.string().optional(),
  address15CondoInsuranceAgentEmail: OptionalEmailString,
  address15CondoInsuranceAgentPhone: OptionalPhoneNumber,
  address15CondoInsuranceCompanyName: z.string().optional(),
  address15CondoInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15CondoInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15CondoInsuranceCompanyAddressCity: z.string().optional(),
  address15CondoInsuranceCompanyAddressState: z.string().optional(),
  address15CondoInsuranceCompanyAddressZip: z.string().optional(),
  address15CondoInsurancePolicyNumber: z.string().optional(),
  address15CondoInsurancePolicyStart: DateString.optional(),
  address15CondoInsurancePolicyEnd: DateString.optional(),
  address15CondoInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15EarthquakeInsuranceIsEscrowed: Checkbox.optional(),
  address15EarthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15EarthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15EarthquakeInsuranceAgentName: z.string().optional(),
  address15EarthquakeInsuranceAgentEmail: OptionalEmailString,
  address15EarthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  address15EarthquakeInsuranceCompanyName: z.string().optional(),
  address15EarthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15EarthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15EarthquakeInsuranceCompanyAddressCity: z.string().optional(),
  address15EarthquakeInsuranceCompanyAddressState: z.string().optional(),
  address15EarthquakeInsuranceCompanyAddressZip: z.string().optional(),
  address15EarthquakeInsurancePolicyNumber: z.string().optional(),
  address15EarthquakeInsurancePolicyStart: DateString.optional(),
  address15EarthquakeInsurancePolicyEnd: DateString.optional(),
  address15EarthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15UmbrellaInsuranceIsEscrowed: Checkbox.optional(),
  address15UmbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15UmbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15UmbrellaInsuranceAgentName: z.string().optional(),
  address15UmbrellaInsuranceAgentEmail: OptionalEmailString,
  address15UmbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  address15UmbrellaInsuranceCompanyName: z.string().optional(),
  address15UmbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15UmbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15UmbrellaInsuranceCompanyAddressCity: z.string().optional(),
  address15UmbrellaInsuranceCompanyAddressState: z.string().optional(),
  address15UmbrellaInsuranceCompanyAddressZip: z.string().optional(),
  address15UmbrellaInsurancePolicyNumber: z.string().optional(),
  address15UmbrellaInsurancePolicyStart: DateString.optional(),
  address15UmbrellaInsurancePolicyEnd: DateString.optional(),
  address15UmbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15SinkholeInsuranceIsEscrowed: Checkbox.optional(),
  address15SinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15SinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15SinkholeInsuranceAgentName: z.string().optional(),
  address15SinkholeInsuranceAgentEmail: OptionalEmailString,
  address15SinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  address15SinkholeInsuranceCompanyName: z.string().optional(),
  address15SinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15SinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15SinkholeInsuranceCompanyAddressCity: z.string().optional(),
  address15SinkholeInsuranceCompanyAddressState: z.string().optional(),
  address15SinkholeInsuranceCompanyAddressZip: z.string().optional(),
  address15SinkholeInsurancePolicyNumber: z.string().optional(),
  address15SinkholeInsurancePolicyStart: DateString.optional(),
  address15SinkholeInsurancePolicyEnd: DateString.optional(),
  address15SinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15WildfireInsuranceIsEscrowed: Checkbox.optional(),
  address15WildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15WildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15WildfireInsuranceAgentName: z.string().optional(),
  address15WildfireInsuranceAgentEmail: OptionalEmailString,
  address15WildfireInsuranceAgentPhone: OptionalPhoneNumber,
  address15WildfireInsuranceCompanyName: z.string().optional(),
  address15WildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15WildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15WildfireInsuranceCompanyAddressCity: z.string().optional(),
  address15WildfireInsuranceCompanyAddressState: z.string().optional(),
  address15WildfireInsuranceCompanyAddressZip: z.string().optional(),
  address15WildfireInsurancePolicyNumber: z.string().optional(),
  address15WildfireInsurancePolicyStart: DateString.optional(),
  address15WildfireInsurancePolicyEnd: DateString.optional(),
  address15WildfireInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15SewerInsuranceIsEscrowed: Checkbox.optional(),
  address15SewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15SewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15SewerInsuranceAgentName: z.string().optional(),
  address15SewerInsuranceAgentEmail: OptionalEmailString,
  address15SewerInsuranceAgentPhone: OptionalPhoneNumber,
  address15SewerInsuranceCompanyName: z.string().optional(),
  address15SewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15SewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15SewerInsuranceCompanyAddressCity: z.string().optional(),
  address15SewerInsuranceCompanyAddressState: z.string().optional(),
  address15SewerInsuranceCompanyAddressZip: z.string().optional(),
  address15SewerInsurancePolicyNumber: z.string().optional(),
  address15SewerInsurancePolicyStart: DateString.optional(),
  address15SewerInsurancePolicyEnd: DateString.optional(),
  address15SewerInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15EquipmentInsuranceIsEscrowed: Checkbox.optional(),
  address15EquipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15EquipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15EquipmentInsuranceAgentName: z.string().optional(),
  address15EquipmentInsuranceAgentEmail: OptionalEmailString,
  address15EquipmentInsuranceAgentPhone: OptionalPhoneNumber,
  address15EquipmentInsuranceCompanyName: z.string().optional(),
  address15EquipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15EquipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15EquipmentInsuranceCompanyAddressCity: z.string().optional(),
  address15EquipmentInsuranceCompanyAddressState: z.string().optional(),
  address15EquipmentInsuranceCompanyAddressZip: z.string().optional(),
  address15EquipmentInsurancePolicyNumber: z.string().optional(),
  address15EquipmentInsurancePolicyStart: DateString.optional(),
  address15EquipmentInsurancePolicyEnd: DateString.optional(),
  address15EquipmentInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15TitleInsuranceIsEscrowed: Checkbox.optional(),
  address15TitleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15TitleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15TitleInsuranceAgentName: z.string().optional(),
  address15TitleInsuranceAgentEmail: OptionalEmailString,
  address15TitleInsuranceAgentPhone: OptionalPhoneNumber,
  address15TitleInsuranceCompanyName: z.string().optional(),
  address15TitleInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15TitleInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15TitleInsuranceCompanyAddressCity: z.string().optional(),
  address15TitleInsuranceCompanyAddressState: z.string().optional(),
  address15TitleInsuranceCompanyAddressZip: z.string().optional(),
  address15TitleInsurancePolicyNumber: z.string().optional(),
  address15TitleInsurancePolicyStart: DateString.optional(),
  address15TitleInsurancePolicyEnd: DateString.optional(),
  address15TitleInsuranceForcedPlacedFlag: Checkbox.optional(),
  address15OtherInsuranceIsEscrowed: Checkbox.optional(),
  address15OtherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  address15OtherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  address15OtherInsuranceAgentName: z.string().optional(),
  address15OtherInsuranceAgentEmail: OptionalEmailString,
  address15OtherInsuranceAgentPhone: OptionalPhoneNumber,
  address15OtherInsuranceCompanyName: z.string().optional(),
  address15OtherInsuranceCompanyAddressLine1: AddressLine.optional(),
  address15OtherInsuranceCompanyAddressLine2: AddressLine.optional(),
  address15OtherInsuranceCompanyAddressCity: z.string().optional(),
  address15OtherInsuranceCompanyAddressState: z.string().optional(),
  address15OtherInsuranceCompanyAddressZip: z.string().optional(),
  address15OtherInsurancePolicyNumber: z.string().optional(),
  address15OtherInsurancePolicyStart: DateString.optional(),
  address15OtherInsurancePolicyEnd: DateString.optional(),
  address15OtherInsuranceForcedPlacedFlag: Checkbox.optional(),
});

export type MultiPropertyInsuranceFields = z.infer<typeof MultiPropertyInsuranceFields>;
